export default {
  "The Operator is not registered. Do you want to send a notification to operator to join the platform via email?": "El operador no está registrado. ¿Desea enviar una notificación al operador para que se una a la plataforma por correo electrónico?",
  "Do you want to download all attached files in PDF format?": "¿Desea descargar todos los archivos adjuntos en formato PDF?",
  "unknown_error": "Excepción desconocida",
  "geo_location_error": "Error de geolocalización",
  "region_not_available": "Región no disponible",
  "area_too_large": "Área demasiado grande",
  "area_too_small": "Área demasiado pequeña",
  "invalid_request_data": "Datos de solicitud no válidos",
  "unknown_error_tt": "Cuando ocurre una excepción no controlada; puede deberse a cualquier problema interno del sistema",
  "geo_location_error_tt": "Ocurre cuando no podemos geocodificar inversamente las coordenadas para obtener la dirección",
  "region_not_available_tt": "Cuando las coordenadas de la geocerca se encuentran en una región para la que no disponemos de modelos de deforestación",
  "area_too_large_tt": "Cuando la geocerca tiene un área mayor a la permitida",
  "area_too_small_tt": "Cuando la geocerca tiene un área menor a la que la API de Python puede procesar",
  "invalid_request_data_tt": "Los datos de entrada no son válidos",
  confirmationTitle: "Confirmación",
  "operatorRegisterConfirmation": "El operador no está registrado. ¿Desea enviar una notificación al operador para que se una a la plataforma por correo electrónico?",

  satelliteReport: {
    satelliteReport: "Informes Satelitales",
    generateReport: "Generar Nuevo Informe",
    satelliteReportTooltip:
      "Aquí puede obtener 5 informes satelitales básicos para sus fincas (NDVI, MSAVI, NDRE, RECI, LSWI) para evaluar la salud del cultivo según los niveles de nutrientes y humedad",
    operatorName: "Nombre del Operador",
    issueDate: "Fecha de Emisión",
    selectFarm: "Seleccionar Finca",
    chooseFarm: "Elegir Finca",
    chooseZone: "Elegir Zona",
    genReport: "Generar Informe",
    viewReport: "Ver Informe",
    farmName: "Nombre de la Finca",
    allFarms: "Todas las Fincas",
    zone: "Zona(s)",
    selectReportType: "Seleccionar Tipo de Informe",
    report: "Informe",
    cropHealth: "Salud del Cultivo (NDVI)",
    doi: "Fecha de Interés",
    dateOfImage: "Fecha de la imagen con baja cobertura de nubes",
    reciValues: "Los valores RECI van de 0 a 10",
    ndviValues: "Valores NDVI",
    rangeSubtitle: "Los valores cercanos a 1 indican una vegetación más saludable",
  },

  deforestation: {
    riskLevel: "Riesgo",
    privacyEnabled:"Privacidad habilitada",
    geolocationPrivacySubHeading: "Interruptor para controlar la confidencialidad de los datos de ubicación. Actívalo para marcar la ubicación como confidencial y restringir su visibilidad. Desactívalo para hacer que la ubicación sea accesible públicamente.",
    geolocationPrivacy:"Privacidad de geolocalización",
    
    sendToOperator: "Enviar al operador",
    failedEudrReportDueSetting:'Por favor, asegúrese de que la configuración de las siguientes propiedades esté correctamente configurada: Vencimiento del Informe, Masa Neta, Volumen y Radio.',
    producerData:{
      addProducers:"Agregar Nuevo Productor",
      countryInfo: "Campo para ingresar o mostrar el país asociado con un productor."
    },
    uploadedToEU: "Subido al portal de la UE",
    pending: "Pendiente",
    underReview: "En revisión",
    compliant: "Cumple",
    nonCompliant: "No cumple",
    analyzeDeforestation: "Analizando deforestación",
    analyzingDeforestation: "Analizando deforestación",
    readyToProceed: "Listo para proceder",
    processingFarm: "Procesando granja",
    mitigationRequired: "Mitigación requerida",
    pendingApproval: "Pendiente de aprobación",

    veryHighDeforestationProbability: "Probabilidad de deforestación muy alta",
    highDeforestationProbability: "Probabilidad de deforestación alta",
    mediumDeforestationProbability: "Probabilidad de deforestación media",
    lowDeforestationProbability: "Probabilidad de deforestación baja",
    veryLowDeforestationProbability: "Probabilidad de deforestación muy baja",
    zeroNegligibleDeforestationProbability: "Probabilidad de deforestación cero/negligible",
    manuallyMitigated: "Mitigado manualmente",

    selectCountry: "Seleccionar País",
    internalReferenceNumberMustBeAlphanumeric: "El número de referencia interna debe ser alfanumérico",
    atLeastOneOfSupplierIdOrSupplierNameIsRequired: "Se requiere al menos uno de los campos ID de proveedor o Nombre de proveedor",
    atLeastOneOfOperatorIdOrOperatorNameIsRequired: "Se requiere al menos uno de los campos ID de operador o Nombre de operador",
    netMassIsRequired: "Se requiere la masa neta",
    netMassMustBeValid: "La masa neta debe ser válida",
    thisFieldIsRequired: "Este campo es obligatorio",
    volumeMustBeNumeric: "El volumen debe ser numérico",
    nameIsRequired: "El nombre es obligatorio",
    firstNameIsRequired: "El nombre es obligatorio",
    lastNameIsRequired: "El apellido es obligatorio",
    countryIsRequired:"El país es obligatorio",

    confirmPdfDownload: "¿Desea descargar todos los archivos adjuntos en formato PDF?", 
    confirmJsonDownload:"¿Desea descargar todos los archivos adjuntos en formato JSON?",
    basicFinalFarmListWithStatus: "Lista de fincas finales básicas con estado",
    detailedInformationIncludingDescriptionOfRiskMitigationActivities: "Información detallada, incluida la descripción de las actividades de mitigación de riesgos",
    completeDocumentIncludingRiskMitigationAndAttachedDocuments: "Documento completo, incluida la mitigación de riesgos y los documentos adjuntos",
    
    existing: "Existente",
    survey: "Encuesta",

    operatorInformation: "Información del Operador", 
    addNewOperator: "Agregar un Nuevo Operador", 
    
    reportAddedSuccessfully: "Reporte agregado exitosamente",
    reportUpdatedSuccessfully: "Reporte actualizado exitosamente",
    itemDeletedSuccessfully : "Elemento eliminado exitosamente.",
    reportDeletedSuccessfully: "Reporte eliminado exitosamente",
    anErrorOccurredWhileDeletingTheReport : "Ocurrió un error al eliminar el reporte.",

    valueMustBeBetween02And4: "El valor debe estar entre 0.2 y 4",

    EUDRDeforestationStatusTT: "Selección del estado de deforestación. Alta Probabilidad de Deforestación: Una categoría específica de evaluación de riesgos asignada a determinadas áreas geográficas según su probabilidad de deforestación o degradación forestal. Ayuda a determinar los requisitos de diligencia debida para los operadores que colocan en el mercado de la UE productos básicos relevantes (como cacao, café, etc.) o productos que los contienen o se fabrican con ellos. Baja Probabilidad de Deforestación: Una categoría de evaluación de riesgos asignada a áreas geográficas que se consideran poco propensas a experimentar deforestación o degradación forestal significativa. Esta designación influye en los requisitos de diligencia debida para los operadores que colocan en el mercado de la UE productos básicos o productos procedentes de estas áreas. Probabilidad de Deforestación Nula/Insignificante: Una probabilidad muy baja o inexistente de que ocurra deforestación. Implica que el riesgo o impacto de la deforestación se considera extremadamente pequeño o insignificante.",
    
    complianceRiskWarnings: "Advertencias de Riesgo de Cumplimiento",
    complianceRiskWarningsInfo: "Muestra el título de la sección, indicando que esta área se centra en las advertencias relacionadas con los riesgos de cumplimiento en el proceso de diligencia debida.",
    locationVerificationTT: "Se refiere al proceso de confirmar y validar la ubicación geográfica de los sitios de producción como parte de los procedimientos de diligencia debida. Implica garantizar que los detalles de ubicación proporcionados, como coordenadas o dirección, representen con precisión la ubicación física donde ocurren las actividades de producción. Esta verificación es crucial para evaluar los impactos ambientales, el cumplimiento del uso de la tierra y la precisión de los datos informados dentro del informe de diligencia debida.", 
    netMassKg: "Masa Neta (kg)",
    volumeM3: "Volumen (m3)",
    volumeM: "Volumen",
    warning: "Advertencia",

    productionPlacesTT: "Ubicaciones donde se fabrican o cultivan bienes.",
    productionPlacesCountryInfo: "Un cuerpo territorial distinto con su propio gobierno y fronteras.",
    productionPlacesProducersInfo: "Entidad responsable de crear o cultivar bienes.",
    totalsTT: "La sección 'Totales' proporciona un resumen de los principales indicadores cuantitativos para todo el conjunto de datos o informe. Agrega datos para ofrecer a los usuarios una visión rápida de las métricas generales, como la masa total del producto, el volumen total del producto, el área del lugar de producción, etc., involucrados en el informe de diligencia debida.",

    AnalysisOfDeforestationStatusTT: "El análisis del estado actual de la deforestación dentro de un área específica, generalmente realizado para evaluar el impacto ambiental o el cumplimiento de los esfuerzos de conservación.",

    complete : "Completo",

    undoDelete: "Deshacer Eliminación",

    verifyingLocationsData: 'Verificando datos de ubicación(es)...',
    crossCheckingWithProductionPlaces: 'Verificando con los lugares de producción...',
    almostTherePleaseHoldOn: 'Casi allí, por favor espera...',
    LocationVerifiedSuccessfully: '¡Ubicación(es) verificadas con éxito!',
    allProductionPlacesAndLocationsHaveBeenConfirmed: '¡Todos los lugares de producción y ubicaciones han sido confirmados!',
    errorCheckingOverlaps: 'Error al verificar superposiciones.',
    farmIsBiggerThan4HectaresItNeedsToBeAPolygon: 'La granja es mayor de 4 hectáreas, necesita ser un polígono',
    failedToFetchSettings: 'No se pueden obtener las configuraciones. Por favor, revise sus configuraciones o contacte con soporte si el problema persiste.',
    farmCountryNotDefined: 'País de la granja no definido.',
    theGeofencesSupposeToBeIn: 'La geocerca se supone que está en',
    butItsIn: 'pero está en',
    geofenceIsInOcean: 'La geocerca o parte de ella está en el océano.',

    existingReport: "Informe de Deforestación Existente",
    dimitraReport: "Informe de Deforestación de Dimitra",

    attachRiskMigrationDocTT: "Indica la acción de asociar o vincular un único documento a todas las fincas identificadas con riesgo de deforestación, generalmente con fines de documentación o cumplimiento normativo.",    
    oneForAllFarms:"Uno para Todas las Fincas",
    oneForEachFarm:"Uno para Cada Finca",
    uploadExistingAssessment:"Subir Evaluación Existente",
    completeDimitraAssessment:"Evaluación por Operador o Proveedor",
    assessmentByFarmer: "Evaluación por el Agricultor",
    approve: "Aprobar",
    conclude: "Concluir",
    approveMessage: "¿Está seguro de que desea aprobar este informe? Al aprobar este informe, se subirá permanentemente a la blockchain. Se generará un enlace de blockchain y un código QR, y no se podrán hacer más actualizaciones o ediciones. ¿Desea continuar?",
    disputeReason: "Motivo de la disputa",
    disputeStatus: "Estado de la disputa",
    disputeArea: "Tamaño del área",
    selectDefaultMeasurementUnit:
      "Seleccionar Unidades de Medida Predeterminadas",
    selectDefaultMeasurementUnitInfo: "Permite la selección de las unidades predeterminadas de medición, incluyendo especificar la unidad, establecer un límite máximo y marcarla como la opción predeterminada.",
    maxLimit: "Límite Máximo",
    maxLimitInfo: "Establece el valor o umbral máximo permitido para un parámetro en particular.",
    asDefault: "Marcar como Predeterminado",
    productMass: "Masa del Producto",
    productMassUnitInfo: "Especifica la unidad para medir la masa de un producto.",
    volumeUnitInfo: "Especifica la unidad para medir el volumen de un producto.",
    operatorInfo: "Se refiere a un individuo o entidad responsable de gestionar o operar un sistema o proceso.",
    supplierInfo: "Una entidad que proporciona bienes o servicios a otra entidad.",
    userTypeInfo: "Clasifica a individuos o entidades según su rol o permisos dentro del sistema.",
    unit: "Unidad",
    userType: "Tipo de Usuario",
    eudrPortalApiKeys: "Claves API del Portal EUDR",
    apiKey: "Clave API",
    apiSecret: "Secreto API",
    headingCreatedSuccessfully: "Encabezado creado con éxito",
    headingOrderSuccessfullyUpdated: "Orden de encabezados actualizado con éxito",
    headingUpdatedSuccessfully: "Encabezado actualizado con éxito",
    questionTypeNotDefined: "Tipo de pregunta no definido",
    assessmentRiskMitigationLvl:
      "Niveles de Mitigación del Riesgo de Evaluación",
    assessmentRiskMitigationLvlInfo: "Categoriza la gravedad de los riesgos asociados con el uso de la tierra, las prácticas forestales y la expansión agrícola. Estos niveles ayudan a identificar el impacto potencial de las actividades en las áreas boscosas y guían las acciones adecuadas para mitigar las consecuencias negativas. Categoriza los niveles de las estrategias de mitigación de riesgos, incluyendo muy alto, alto, medio, bajo y cero/insignificante.",

    dynamicExpiryTime: "Periodo de Expiración Dinámico",
    dynamicExpiryTimeInfo: "Establece un período de tiempo después del cual ciertos datos o configuraciones caducan automáticamente. Configura ajustes relacionados con los informes de deforestación, incluyendo opciones para la renovación automática.",
    eudrDeforestationAssessment: "Evaluación de la Deforestación EUDR",
    autoRenewalIf:
      "Renovación Automática al Añadir al Informe de Diligencia Debida",
    declarationStatements: "Declaraciones",
    declarationStatementsInfo: "Declaraciones realizadas por la parte responsable certificando la exactitud, integridad y autenticidad de la información contenida en el informe.",
    filterDeclaration: "Filtrar Declaraciones",
    declarationTitle: "Título de la Declaración",
    declarationTitleInfo: "Título o encabezado para una declaración, proporcionando contexto o resumiendo su contenido.",
    applicableCountry: "Países Aplicables",
    applicableCountryInfo: "Lista de los países a los que se aplican ciertos ajustes o regulaciones.",
    addMore: "Añadir Más",
    autoRenewal: "Renovación automática",
    createNewAssessment: "Crear nueva evaluación",
    userDimitraAssessment: "Usar Evaluaciones de Dimitra",
    eudrComplianceStatus: "Estado de Cumplimiento EUDR",
    shipmentList: "Lista de Envíos",
    generalData: "Datos Generales",
    check: "Verificar",
    deforestationComplianceReport: "Informes de Cumplimiento de Deforestación",
    noDeforestationComplianceReport:
      "No se Encontró Informe de Cumplimiento de Deforestación",
    loadingDeforestationComplianceReport:
      "Cargando Informe de Cumplimiento de Deforestación",
    farmName: "Nombre de la Finca",
    farmRegistrationId: "ID de Registro de la Finca",
    farmerName: "Nombre del Agricultor",
    farmerRegistrationId: "ID de Registro del Agricultor",
    uniqueFarmerId: "ID Único del Agricultor",
    uniqueFarmId: "ID Único de la Finca",
    farmLocation: "Ubicación de la Finca",
    area: "Área",
    farmAddress: "Dirección de la Finca",
    dateOfRequest: "Fecha de Solicitud",
    status: "Estado",
    settings: "Configuraciones",

    farmLatitude: "Latitud de la Finca",
    farmLongitude: "Longitud de la Finca",
    shareQRCode: "Compartir Código QR",
    copy: "Copiar",

    allCountries: "Todos los Países",
    allRegions: "Todas las Regiones",
    allFarms: "Todas las Fincas",
    allProducer:"Todos los productores",
    viewCertificate: "Ver Certificado",

    assignmentIssued: "Asignación Emitida",

    complianceCertification: "Certificación de Cumplimiento",
    noComplianceCertification: "No se Encontró Certificación de Cumplimiento",
    loadingComplianceCertification: "Cargando Certificación de Cumplimiento",

    eudrForestAssessment: "Evaluaciones Forestales EUDR",
    assessmentReport: "Informe de Evaluación",
    downloadPDF: "Descargar PDF",
    back: "Atrás",
    farmDetails: "Detalles de la Finca",

    dimitraFarmId: "ID de Finca Dimitra",
    dimitraFermerId: "ID de Agricultor Dimitra",

    totalGeofenceAreaHA: "Área Total de Geovalla (AC)",
    forestLossHA: "Pérdida de Bosque (AC)",
    forestGainHA: "Ganancia de Bosque (AC)",
    forestUnchangedHA: "Bosque Sin Cambios (AC)",
    shareCertificate: "Compartir Certificado",
    forestUnchanged: "Bosque Sin Cambios",
    forestLoss: "Pérdida de Bosque",
    forestGain: "Ganancia de Bosque",
    totalGeofenceArea: "Área Total de Geovalla",
    deforestationProbability: "Probabilidad de Deforestación",
    colorCode: "Código de Color",
    geofenceArea: "Área de Geovalla",
    percentageOfGeofenceArea: "Porcentaje del Área de Geovalla",
    view: "Ver",
    customization: "Personalización",
    recordsPerpage: "Registros por Página",
    restoreDefault: "Restaurar Valores Predeterminados",
    apply: "Aplicar",
    forestAssessmentHelp:
      "Si tiene preguntas sobre este informe o necesita ayuda para entenderlo, contáctenos a través del Servicio de Ayuda.",
    overallDeforestationProbability: "Probabilidad General de Deforestación",
    zeroOrNegligible: "Cero/Insignificante",
    high: "Alta",
    allStatus: "Todos los Estados",
    low: "Baja",
    veryHigh: "Muy Alta",
    medium: "Media",
    veryLow: "Muy Baja",
    assessmentIssued: "Evaluación Emitida",
    certificateIssued: "Certificado Emitido",
    assessmentNo: "Número de Evaluación",
    blockchainCertificateDesc:
      "El Hash de Validación del Certificado Blockchain Estará Disponible Tras la Aceptación del Certificado",
    blockchainValidation: "Validación del Certificado Blockchain",
    openBlockchainPage: "Abrir Página Blockchain",
    clickLinkDesc:
      "Haga clic en el enlace de arriba para validar el certificado en la blockchain",
    tooltip: {
      dimitraFarmId:
        "Identificador único asociado con una Finca específica en el sistema Dimitra.",
      farmName: "El nombre designado de la finca.",
      farmRegistrationId: "Número de registro de la finca.",
      farmLocation:
        "Coordenadas geográficas específicas o ubicación de la finca.",
      dimitraFermerId:
        "Un identificador distinto vinculado a un agricultor individual dentro del sistema Dimitra.",
      farmerName: "Identificación de la persona responsable de la finca.",
      farmerRegistrationId: "Número de registro del agricultor.",
      assessmentNo: "Número único asignado a la evaluación.",
    },
    red: "Rojo",
    Yellow: "Amarillo",
    transparent: "Transparente",
    darkRed: "Rojo Oscuro",
    brightRed: "Rojo Brillante",
    orange: "Naranja",
    lightBlue: "Azul Claro",
    teal: "Verde azulado",
    zeroOrNegligibleProbability:
      "Probabilidad de Deforestación Cero/Insignificante",
    riskDetected: "Riesgo detectado",
    zeroOrNegligibleRisk: "Riesgo cero/insignificante",
    veryLowProbability: "Probabilidad de Deforestación Muy Baja",
    lowProbability: "Probabilidad de Deforestación Baja",
    mediumProbability: "Probabilidad de Deforestación Media",
    highProbability: "Probabilidad de Deforestación Alta",
    veryHighProbability: "Probabilidad de Deforestación Muy Alta",
    zeroOrNeglegible: "Cero o Insignificante",
    zeroorneglegible: "Cero o Insignificante",
    High: "Alta",
    Low: "Baja",
    "Zero/Negligible": "Cero/Insignificante",
    "Zero/Negligible Deforestation Probability":
      "Probabilidad de deforestación cero/insignificante",
    "Zero Deforestation Probability": "Probabilidad de deforestación cero",
    "Very Low Deforestation Probability":
      "Muy baja probabilidad de deforestación",
    "Low Deforestation Probability": "Baja probabilidad de deforestación",
    "Medium Deforestation Probability": "Probabilidad media de deforestación",
    "High Deforestation Probability": "Alta probabilidad de deforestación",
    "Very High Deforestation Probability":
      "Muy alta probabilidad de deforestación",
    zeroOrNeglegibleProbability:
      "Probabilidad de Deforestación Cero/Despreciable",
    very_high: "Muy Alta",
    very_low: "Muy Baja",
    Orange: "Naranja",
    locationName: "Nombre de la ubicación",
    dueDeligence: "Debida Diligencia",
    supplierInformation: "Información del Proveedor",
    addNewSupplier: "Agregar un Nuevo Proveedor",
    name: "Nombre",
    lastName: "Apellido",
    email: "Correo Electrónico",
    phoneNumber: "Número de Teléfono",
    enterSupplierName: "Ingresar Nombre del Proveedor",
    enterSupplierLastName: "Ingresar Apellido del Proveedor",
    enterSupplierFirstName: "Ingresar Nombre del Proveedor",
    enterOperatorName: "Ingresar Nombre del Operador",
    enterEmailAddress: "Ingresar Dirección de Correo Electrónico",
    enterPhoneNumber: "Ingresar Número de Teléfono",
    whoWillAddPlace: "¿Quién Agregará los Datos del Lugar de Producción?",
    companyId: "ID de la Empresa",
    disputeId: "ID de disputa",
    activity: "Actividad",
    placeOfActivity: "Lugar de la Actividad",
    countryOfActivity: "País de la Actividad",
    operatorPlaceOfActivity: "Lugar de Actividad del Operador",
    operatorCountryOfActivity: "País de Actividad del Operador",
    countryOfEntry: "País de Entrada",
    productDetail: "Detalles del Producto",
    subProduct: "Sub-Producto",
    productionDescription: "Descripción del Producto",
    netMass: "Masa Neta",
    volume: "Volumen",
    scietificName: "Nombre Científico",
    commonName: "Nombre Común",
    eudrDueDeligenceReports: "Informes de Debida Diligencia EUDR",
    EUDRAssessmentReport: "Informe de Evaluación EUDR",
    createNewReport: "Crear Nuevo Informe",
    eudrRefNo: "No. de Referencia EUDR",
    eudrRefNoInfo: "Funcionalidad para encontrar información específica relacionada con el envío.",
    statusInfo: "El estado actual del envío en relación con el informe de debida diligencia.",
    eudrAndInternalRefNo: "No. de Referencia EUDR / Interna",
    exporterAndSupplier: "Exportador y Proveedor",
    internalRefNo: "No. de Referencia Interna",
    supplier: "Proveedor",
    quantity: "Cantidad",
    product: "Producto",
    noOfFarms: "Número de Granjas",
    farmsAndQuantity: "Granjas y Cantidad",
    country: "País",
    lastUpdated: "Última Actualización",
    dueDeligenceStatus: "Estado de la Debida Diligencia",
    edurDueDeligenceStatus: "Estado de la Debida Diligencia EUDR",
    reject: "Rechazar",
    discard: "Descartar",
    saveAndContinueLater: "Guardar y continuar más tarde",
    requestAdditionalInformation: "Solicitar información adicional",
    requestAdditionalInformationShort: "Solicitar más información",
    uploadToEudr: "Subir a EUDR",
    productionPlaces: "Lugares de Producción",
    next: "Siguiente",
    dueDeligenceReportCreation: "Creación de Informe de Debida Diligencia",
    producer: "Productor",
    select: "Seleccionar",
    productionPlacesFarmAndFarmId:
      "Lugar de producción (Finca) y ID de la granja",
    producerName: "Nombre del Productor",
    addressOfProduction: "Dirección de Producción",
    type: "Tipo",
    geofence: "Geovalla",
    areaHa: "Área (ha)",
    editGeofence: "Editar Geovalla",
    totals: "Totales",
    locationVerification: "Verificación de Ubicación",
    AnalysisOfDeforestationStatus: "Análisis del Estado de Deforestación",
    EUDRDeforestationStatus: "Estado de Deforestación EUDR",
    removeAllLowRiskFarm: "Eliminar todas las granjas de bajo riesgo",
    removeAllHighRiskFarm: "Eliminar todas las granjas de alto riesgo",
    removeAllMediumRiskFarm: "Eliminar todas las granjas de riesgo medio",
    attachRiskMigrationDoc:
      "Adjunte un documento de mitigación de riesgos para todas las granjas de alto riesgo",
    removedFarms: "Granjas eliminadas de la lista",
    generateCertificate: "Generar Certificado",
    viewDisputeHistory: "Ver Historial de Disputas",
    disputeAssessment: "Evaluación de Disputas",

    reportDetails: "Detalles del Informe",
    productionPlace: "Lugar de Producción",
    regionalRiskAssessment: "Evaluación de Riesgo Regional",
    EUDRDeforestationAssessment: "Evaluación de Deforestación EUDR",
    EUDRcountry: "El país donde se encuentra la explotación, vinculado al producto en el informe de diligencia debida. Ayuda a garantizar la trazabilidad geográfica tal y como exige la normativa EUDR.",
    riskAssessment: "Evaluación de Riesgos",
    legalInformation: "Información Legal",
    finalReport: "Informe Final",
    editGeolocation: "Editar Geolocalización",
    producerCountry: "País del Productor",
    manuallyAddData: "Agregar Datos Manualmente",
    drawGeofence: "Dibujar Geovalla",
    uploadFile: "Subir Archivo",
    typeyourlocation: "Escribe el nombre/dirección de tu ubicación",
    numberOfPoints: "Número de Puntos del Polígono",
    viewGeolocation: "Ver Geolocalización",
    geoLocation: "Geolocalización",
    Point: "Punto",
    Circular: "Circular",
    Polygon: "Polígono",
    selectFileToUpload: "Seleccione el archivo para cargar los datos",
    selectFileToUploadData: "Selecciona un archivo para cargar datos",
    submissionDate: "Fecha de Envío",
    eudrReferenceNo: "Nº de Referencia EUDR",
    internalReferenceNo: "Nº de Referencia Interna",
    exporter: "Exportador",
    exporterInfo: "Nombre del exportador. La entidad o parte responsable de exportar los bienes.",
    importer: "Importador",
    importerInfo: "Nombre del importador. La entidad o parte responsable de importar los bienes.",
    shipmentReferenceNo: "Nº de Referencia del Envío",
    shipmentReferenceNoInfo: "Un identificador único utilizado para referenciar el envío.",
    ownerShipType: "Tipo de Propiedad",
    ownerShipTypeInfo: "El tipo de propiedad asociada con el envío.",
    buyer: "Comprador",
    buyerName: "Nombre del comprador",
    port_of_origin: "Puerto de Origen",
    port_of_origin_info: "La ubicación donde se origina el envío.",
    port_of_destination: "Puerto de Destino",
    port_of_destination_info: "El puerto de destino previsto para el envío.",
    no_of_stops: "Nº de Paradas",
    shipping_line: "Línea de Navegación",
    shipping_line_info: "La empresa o entidad responsable de transportar el envío.",
    expected_arrival_date: "Fecha de Llegada Estimada",
    expected_arrival_date_info: "Fecha anticipada de llegada del envío a su destino.",
    container_id: "ID del Contenedor",
    container_id_info: "Identificador único para el contenedor de envío utilizado en el envío.",
    container_type: "Tipo de Contenedor",
    container_type_info: "El tipo o categoría de contenedor de envío.",
    container_size: "Tamaño del Contenedor (ft)",
    container_size_info: "Las dimensiones físicas del contenedor de envío.",
    container_capacity: "Capacidad del Contenedor (Toneladas)",
    container_capacity_info: "La carga máxima o capacidad del contenedor de envío.",
    eudr_reference_number: "Número de Referencia EUDR",

    select_default_measurement_units:
      "Seleccionar Unidades de Medida Predeterminadas",
    radius: "Radio",
    maximum_limit: "Límite Máximo",
    product_mass: "Masa del Producto",
    user_type: "Tipo de Usuario",
    eudr_api_keys: "Claves de API del Portal EUDR",
    api_key: "Clave de API",
    api_secret: "Secreto de API",
    assessment_risk_mitigation_levels:
      "Niveles de Mitigación de Riesgos de la Evaluación",
    dynamic_expiry_time_period: "Período de Expiración Dinámica",
    eudr_deforestation_assessment: "Evaluación de Deforestación EUDR",
    auto_renewal: "Renovación Automática",
    auto_renewal_when_added_to_the_due_diligence_report:
      "Renovación Automática Cuando se Añade al Informe de Diligencia Debida",
    declaration_statements: "Declaraciones",
    filter_declaration_statements: "Filtrar Declaraciones",
    showing_all: "Mostrando Todo",
    declaration_title: "Título de la Declaración",
    applicable_countries: "Países Aplicables",
    enabled: "Habilitado",
    disabled: "Deshabilitado",
    add_more: "Añadir Más",
    mark_as_default: "Marcar como Predeterminado",
    locationVerificationTab:{
      confirmationTitle: "Confirmación",
      confirmationMessage: "Está a punto de editar los datos de geolocalización de esta explotación. Tenga en cuenta que cualquier cambio en la geolocalización requerirá una nueva verificación de todos los pasos relacionados, incluida la verificación de la ubicación, el análisis de la deforestación y la evaluación del riesgo regional (comprobaciones de zonas protegidas e indígenas). Los cambios en el nombre de la explotación o del agricultor no requerirán una nueva verificación. ¿Desea continuar?",
    },
    locationModified: {
      headerTitle: "Ubicaciones Modificadas",
      headerDescription: "Hemos detectado que las siguientes ubicaciones han sido modificadas y necesitan ser verificadas nuevamente.",
    },
    processingDialog: {
      modalHeader: "Analizando el Estado de la Deforestación",
      modalDescription_first: "Analizando el Estado de la Deforestación EUDR",
      modalDescription_second: "Tus granjas están siendo sometidas a un Análisis Automatizado de Deforestación. Serás redirigido a la página de la lista de Informes de Diligencia Debida para ver el estado.",
    },
    farmList: {
      title: "Listado de granjas EUDR",
      addFarmGeofenceManually: "Agregar geocerca de granja manualmente",
      importGeofenceInBulk: "IMPORTAR GEO-CERCAS EN MASA",
      searchPlaceHolder: "Buscar por nombre de agricultor",
      generateCertificate: "Generar certificado",
      requestAssementReport: "Solicitar informe de evaluación",
      producer: "Productor",
      farmNameAndId: "Nombre y ID de la granja",
      addressOfProduction: "Dirección de producción",
      registrationDate: "Fecha de registro",
      eudrDeforestationStatus: "Estado de deforestación EUDR",
      riskAssessmentStatus: "Estado de evaluación de riesgos",
      assessmentTitle: "Título de la evaluación",
      assessmentDescription: "Descripción de la evaluación",
      submissionDate: "Fecha de envío",
      expiryDate: "Fecha de expiración",
      assessmentStatus: "Estado de la evaluación",
      downloadAsKmx: "Descargar como KMX",
      downloadAsKml: "Descargar como KML",
      downloadAsShp: "Descargar como SHP",
      downloadAsCsv: "Descargar como CSV",
      downloadAsExcel: "Descargar como EXCEL",
      downloadAsPdf: "Descargar como PDF",
      downloadAsGeoJson: "Descargar como GeoJSON",
      loadingFarms: "Cargando granjas",
    },
    dueDeligenceReport:
      "Configuración del Informe de Diligencia Debida Pública",
    allowPublicDownload:
      "Permitir la descarga pública de geocercas de granjas en formato GeoJson",
    showDeforestationSummary:
      "Mostrar resumen de riesgo de deforestación EUDR por categoría",
    cancel: "Cancelar",
    createShipment: "Crear Envío",
    actions: "Acciones",
    operator: "Operador",
    download: "Descargar",
    print: "Imprimir",
    loading: "Cargando...",

    deforestationAssessmentRiskToleranceLevel:
      "Nivel de Tolerancia al Riesgo de Evaluación de Deforestación",
    deforestationAssessmentRiskToleranceLevelInfo:
      "Utilice esta herramienta para configurar qué % de deforestación, para cada calificación, es aceptable dentro de su proceso de Evaluación de Riesgos. Las granjas con un riesgo menor o igual al definido se considerarán aptas para permanecer en el DDS, sin necesidad de llevar a cabo la Mitigación de Riesgos.",
      tons: "Toneladas",

      failedToDeleteQuestion: "Error al eliminar la pregunta",
      questionOrderSuccessfullyUpdated: "Orden de preguntas actualizado con éxito",
      assessmentUpdatedSuccessfully: "Evaluación actualizada con éxito",
      pleaseWaitCurrentlyUpdatingChecklist: "Por favor espere, actualizando lista de verificación",
     
      riskMitigation: "Mitigación de Riesgos",
      riskMitigationHistory: "Historial de Mitigación de Riesgos",
      signParticipationSurvey : "¿Podría firmar digitalmente para confirmar su participación en esta encuesta?",
      signedBy: "Firmado digitalmente por:",
      assessmentRiskMitigation: "Mitigación de Riesgos de Evaluación",
      assessmentDetails: "Detalles de la evaluación",
      dontShowWarning: "No vuelvas a mostrar esta advertencia.",
      dateSubmitted: "Fecha de envío",
      addAComment: "Añadir un comentario",
      changeAssignee: "Cambiar asignado",
      changeStatus: "Cambiar estado",
      assignedUser: "Usuario asignado",
      selectAssignee: "Seleccionar asignado",
      reply: "Responder",
      discussion: "Discusión",
      attachment: "Adjunto",
      sizeKb: "Tamaño (KB)",
      dateAdded: "Fecha añadida",
      
      loadingProductionPlaces: "Cargando lugares de producción",
      shipmentStatus:"Estado del Envío",
      viewStops:"Ver Paradas",
      enRoute:"En Camino",
      delivered:"Entregado",
      failed:"Fallado",
      removeEudrDeforestationStatus: "Eliminar Estado de Deforestación EUDR",
      riskAssessmentStatusIsRequired: "El estado de evaluación de riesgos es obligatorio",
      requestAdditionalInformationPage: {
        descriptionLabel: "Proporcione comentarios o instrucciones específicas en el cuadro de texto a continuación. Una vez enviado, se notificará al proveedor y se le otorgará acceso para editar el informe de diligencia debida. Se le notificará cuando el proveedor actualice el informe.",
        shareAccessLabel: "El proveedor actualmente no tiene acceso a este informe. ¿Le gustaría compartir el acceso con el proveedor? Por favor, elija cómo le gustaría compartir el acceso:",
        shareCompleteReportLabel: "Compartir informe completo",
        shareSpecificStepLabel: "Compartir paso específico"
      },
      issueFound: "Problema encontrado",
      riskWarningModal: {
        issuesFound: "{count} problemas encontrados",
        farmId: "ID de la finca",
        issueId: "ID del problema",
        lastChecked: "Última verificación",
        technicalDetails: "Detalles técnicos",
        showing: "Mostrando {from}–{to} de {total} problemas",
        downloadIssueLog: "Descargar registro de problemas",
        noIssues: "No se encontraron problemas",
        loadFailed: "No se pudieron cargar los detalles del problema",
        unnamedFarm: "Finca sin nombre",
        searchPlaceholder: "Buscar por nombre o ID de la finca…",
        allIssueTypes: "Todos los tipos de problema",
        whatHappened: "Qué pasó",
        whatToDoNext: "Qué hacer a continuación",
        viewStep: "Abrir paso",
        checkHistory: "Historial de verificaciones",
        time: "Hora",
        event: "Evento",
        result: "Resultado",
        copyLog: "Copiar registro",
        logCopied: "Registro del problema copiado",
        noHistory: "Aún no se ha registrado ninguna verificación para esta finca.",
        technicalDetailsHint: "Identificadores y valores sin procesar para soporte",
        chips: {
          action_required: "Acción requerida",
          needs_review: "Requiere revisión",
          check_failed: "Verificación fallida",
          not_checked: "Sin verificar",
          not_started: "No iniciado",
          pending_approval: "Pendiente de aprobación",
        },
        events: {
          farm_registered: "Finca registrada",
          location_checked: "Verificación de ubicación registrada",
          assessment_requested: "Evaluación solicitada",
          result_recorded: "Resultado registrado",
          mitigation_added: "Mitigación añadida",
          dispute_resolved: "Disputa resuelta",
          assessment_started: "Evaluación iniciada",
          assessment_updated: "Evaluación actualizada",
        },
        results: {
          started: "Iniciado",
          completed: "Completado",
          needs_review: "Requiere revisión",
          check_failed: "Verificación fallida",
          pending: "Pendiente",
          approved: "Aprobado",
          rejected: "Rechazado",
        },
        issues: {
          ocean: {
            title: "La ubicación está en el océano",
            finding: "Las coordenadas de la finca corresponden a un punto en el océano, por lo que no se puede verificar el lugar de producción.",
            action: "Corrija las coordenadas o el límite de la finca en Verificación de ubicación.",
          },
          country_mismatch: {
            title: "El país no coincide",
            finding: "La finca está en {detected}, pero el país de producción del informe es {expected}.",
            action: "Corrija la ubicación de la finca o actualice el país de producción en Detalles del informe.",
          },
          point_over_4ha: {
            title: "Ubicación por punto de más de 4 ha",
            finding: "La finca tiene {area} ha pero solo una ubicación por punto. El EUDR exige un polígono para parcelas de más de 4 ha.",
            action: "Añada un límite poligonal para esta finca.",
          },
          country_not_defined: {
            title: "País de producción no definido",
            finding: "El informe no tiene país de producción, por lo que la ubicación de la finca no se puede comparar.",
            action: "Defina el país de producción en Detalles del informe.",
          },
          polygon_overlap: {
            title: "El límite se superpone con otra finca",
            finding: "El límite de esta finca se superpone con: {overlaps}.",
            action: "Revise ambos límites y corrija el incorrecto, o elimine la finca duplicada.",
          },
          deforestation_risk: {
            title: "Riesgo de deforestación detectado",
            finding: "La evaluación de deforestación devolvió \"{status}\" para esta finca.",
            action: "Revise el resultado y añada mitigación o evidencia, o retire la finca del informe.",
          },
          assessment_incomplete: {
            title: "Evaluación incompleta",
            finding: "La evaluación de deforestación no pudo producir un resultado para esta finca (NA).",
            action: "Vuelva a ejecutar la evaluación de deforestación o revise el límite de la finca.",
          },
          not_assessed: {
            title: "Aún no evaluada",
            finding: "No se ha realizado ninguna evaluación de deforestación para esta finca.",
            action: "Ejecute la evaluación de deforestación EUDR para esta finca.",
          },
          assessment_missing: {
            title: "Evaluación no iniciada",
            finding: "Esta finca aún no tiene respuesta para esta evaluación.",
            action: "Complete la evaluación para esta finca.",
          },
          assessment_not_approved: {
            title: "Evaluación no aprobada",
            finding: "La evaluación de esta finca está en \"{status}\", no aprobada.",
            action: "Revise y apruebe la evaluación para esta finca.",
          },
        },
      },
      complianceRiskWarningsTT: "Las notificaciones de advertencia de riesgos le alertan sobre posibles problemas de cumplimiento en cada paso del proceso de diligencia debida. Estas notificaciones ayudan a garantizar que se identifiquen todos los riesgos antes de proceder a la siguiente etapa. Puede habilitar o deshabilitar estas alertas en cualquier momento en la Configuración del Informe o durante la creación del informe.",
      eudrVerificationNo:"Número de verificación",
      eudrVerificationNoTT:"Número de verificación recibido de EUDR",
      statusLegend: "Leyenda de Estado",
      statusLegendInfo: "La leyenda de estado proporciona una visión general rápida del estado actual del informe de diligencia debida. Se utiliza para indicar el estado actual del informe y las acciones que se pueden tomar para actualizarlo.",
      sentToExporter: "Enviado al Exportador",
      approved: "Aprobado / En Blockchain",
      updateRequired: "Actualización Requerida",
      rejected: "Rechazado",
      noExporterFound: "No se encontró exportador",
      exporterFoundSuccessfully: "Exportador encontrado con éxito",
      enterExporterEmail: "Ingrese el correo electrónico del exportador",
      shareReport: "Compartir informe",
      exporterInformation: "Información del exportador",
      pleaseEnterExporterEmail: "Por favor, ingrese el correo electrónico del exportador",

      localDbVerificationConfig: "Configuración de Verificación de Base de Datos Local",
      localDBVerification: "Verificación de Base de Datos Local",
      farmAndFarmId: "Finca e ID de Finca",
      farmerIdCheck: "Verificación de ID del Agricultor",
      farmNationalStatus: "Estado Nacional de la Finca",
      geofenceOverlapCheck: "Verificación de Superposición de Geocercas",
      action: "Acción",
      edit: "Editar",
      delete: "Eliminar",
      farmIDStatusDescription: "Un ID de agricultor 'Sin coincidencia' no convierte la finca en no conforme",
      attachOneRiskMitigationForAllNonComplaint: "Adjuntar un documento de mitigación de riesgos para todas las fincas no conformes",
      removeFarmWithIssue: "Eliminar Finca con Problemas",
      farmId: "ID de Finca",
      farmerId: "ID de Agricultor",
      assignedTo: "Asignado a",
      atLeastOperatorOrExporterOrSupplierMustBeselect: "Se debe seleccionar al menos uno de Operador/Exportador/Proveedor.",
      path: "Ruta",
      geolocationPrivacyTT: "Interruptor para controlar la confidencialidad de los datos de ubicación. Actívalo para marcar la ubicación como confidencial y restringir su visibilidad. Desactívalo para hacer que la ubicación sea accesible públicamente.",
      combinedComplianceLowRisk: "Riesgo Bajo",
      combinedComplianceMediumRisk: "Riesgo Medio",
      mergedComplianceStatus: "Estado de Riesgo",
      analyzingWildfireReports: "Analizando Informes de Incendios Forestales",
      atLeastOneExporterIsRequired: "Se requiere al menos un exportador",
      anErrorOccuredWhileFetchingTheDeforestationReport: "Ocurrió un error al obtener el informe de deforestación.",
      farmRegId: "ID de Reg. de Finca",
      productionPlaceId: "ID de Lugar de Prod.",
      disputeResolution: "Resolución de Disputas",
      internalRefNoKenya: "N.º de Out-turn",
      selectOutturn: "Seleccionar N.º de Out-turn",
      noOutturnsAvailable: "No hay out-turns con lotes trazables disponibles",
      cooperative: "Cooperativa",
      eoriNumber: "Número EORI",
      riskStatus: "Estado de Riesgo",
      riskStatusHigh: "Riesgo Alto",
      riskStatusMedium: "Riesgo Medio",
      riskStatusZeroNegligible: "Cero/Insignificante",
      localComplianceStatus: "Estado de Cumplimiento Local",
      submitForApproval: "Enviar para Aprobación",
      submitForApprovalConfirmationPtsi: "¿Está seguro de que desea enviar este informe para su aprobación? El informe se compartirá con PTSI una vez enviado.",
      submitForApprovalConfirmationKenya: "¿Está seguro de que desea enviar este informe para su aprobación? El informe se compartirá con Kenia una vez enviado.",
      editReport: "Editar Informe",
      editModeEnabled: "Modo de edición habilitado. Ahora puede editar el informe.",
      failedToEnableEditMode: "No se pudo habilitar el modo de edición. Por favor, inténtelo de nuevo.",
      reportEditingRestricted: "Edición del Informe Restringida",
      reportEditingRestrictedMessage: "Este informe está actualmente en revisión por PTSI y ha sido asignado a un trabajador. No puede realizar cambios mientras el proceso de revisión esté en curso.",
      reportEditingRestrictedNote: "Por favor, espere hasta que el equipo de PTSI complete su revisión o desasigne el informe.",
      beingEdited: "En Edición",
      reportBeingEditedTooltip: "Este informe está siendo editado actualmente por el proveedor",
      productionPlaceStatus: "Estado",
      complianceStatusReview: "Cumplimiento de BD Local",
      complianceStatusReviewTT: "Revise el indicador semáforo de cumplimiento de cada lugar de producción según el análisis de deforestación y los datos de riesgo de regencia IYB.",
      complianceStatusReviewDesc: "Revise el indicador de cumplimiento de cada lugar de producción antes de continuar. Verde significa conforme, amarillo es una advertencia y rojo requiere acción o eliminación.",
      complianceTrafficLight: "Indicador de Riesgo",
      viewComplianceIndicator: "Ver detalles del indicador de riesgo",
      complianceTrafficLightCriticalRiskCount: "{count} finca(s) tienen Riesgo Crítico.",
      complianceTrafficLightCriticalRiskMustRemove: "Estas fincas no pueden continuar: deben eliminarse antes de proseguir.",
      complianceTrafficLightQuickActions: "Acciones Rápidas",
      complianceTrafficLightRemoveAllCriticalRiskFarms: "Eliminar Todas las Fincas de Riesgo Crítico ({count})",
      complianceTrafficLightUploadMitigationDocument: "Subir Documento de Mitigación",
      complianceTrafficLightBulkUploadHint: "Suba un documento para aplicar la mitigación a todas las fincas que aún la requieran.",
      wildfireBulkGenerateButton: "Generar Todos los Informes de Incendios Forestales",
      wildfireBulkHint: "Genere de una sola vez el informe de susceptibilidad al fuego a nivel de finca para todos los lugares de producción de este informe.",
      wildfireBulkAnalyzing: "Analizando...",
      wildfireBulkDialogTitle: "Generación Masiva de Informes de Incendios Forestales",
      wildfireBulkConfirmMessage: "Esto envía todos los lugares de producción de este informe ({count} en total) para el procesamiento en segundo plano de la susceptibilidad al fuego. Los informes grandes pueden tardar un tiempo en completarse.",
      wildfireBulkStart: "Iniciar",
      wildfireBulkCancel: "Cancelar",
      wildfireBulkSubmitting: "Enviando lote...",
      wildfireBulkPolling: "Generando informes de incendios forestales para todos los lugares de producción: esto puede tardar un tiempo en informes grandes...",
      wildfireBulkClose: "Cerrar",
      wildfireBulkErrorColumn: "Error",
      complianceTrafficLightMitigationUploaded: "Mitigación subida ✓",
      complianceTrafficLightUploadMitigationRequired: "Subir Mitigación (Obligatorio)",
      complianceTrafficLightLegendCriticalRisk: "Riesgo Crítico",
      trafficLightNotAvailable: "No Disponible",
      complianceTrafficLightCannotProceed: "No se Puede Continuar",
      complianceTrafficLightYesProceed: "Sí, Continuar",
      complianceTrafficLightRemoveAllFarmsTitle: "¿Eliminar todas las fincas de {riskLevel}?",
      complianceTrafficLightCannotBeUndone: "Esta acción no se puede deshacer.",
      complianceTrafficLightYesRemove: "Sí, Eliminar",
      complianceTrafficLightHighRiskCount: "Riesgo Alto ({count})",
      complianceTrafficLightMediumRiskCount: "Riesgo Medio ({count})",
      complianceTrafficLightSelectDocument: "Seleccionar documento",
      complianceTrafficLightAttachDocument: "Adjuntar Documento",
      complianceTrafficLightRevisionRequested: "Revisión solicitada:",
      complianceTrafficLightUploadedDocuments: "Documentos subidos",
      complianceTrafficLightView: "Ver",
      complianceTrafficLightRemove: "Eliminar",
      complianceTrafficLightSelectMitigationDocument: "Seleccionar documento de mitigación",
      complianceTrafficLightUpdateDocument: "Actualizar Documento",
      complianceTrafficLightUpload: "Subir",
      complianceTrafficLightMediumRiskWarning: "Advertencia de Riesgo Medio",
      complianceTrafficLightFarmMediumRisk: "La finca {name} tiene Riesgo Medio.",
      complianceTrafficLightGotIt: "Entendido",
      complianceTrafficLightReadyToProceedTitle: "¿Listo para continuar?",
      complianceTrafficLightCriticalRiskProceedBody: "Tiene {count} finca(s) de Riesgo Crítico que deben eliminarse antes de poder pasar al siguiente paso.",
      complianceTrafficLightAllFarmsGoodBody: "Todas las fincas están correctas. ¿Está seguro de que desea pasar al siguiente paso?",
      complianceTrafficLightMitigationFarmNotFound: "No se pudo encontrar la finca para reenviar la mitigación. Por favor, suba los documentos desde la lista.",
      attachRiskMitigationDocumentForAllNonCompliantFarms: "Adjuntar Documento de Mitigación de Riesgos para Todas las Fincas No Conformes",
      attachOneRiskMitigationDocumentForAllNonCompliantFarms: "ADJUNTAR UN DOCUMENTO DE MITIGACIÓN DE RIESGOS PARA TODAS LAS FINCAS NO CONFORMES",
      fileRequired: "El archivo es obligatorio",
      errorMitigatingFarms: "Error al mitigar las fincas",
      submit: "Enviar",
      remove: "Eliminar",
      restore: "Restaurar",
      farmReportNotAvailable: "El informe de la finca no está disponible",
      assignTo: "Asignado a",
      processingDialogLocalDB: {
        modalHeader: "Analizando la Verificación de BD Local",
        modalDescription_first: "Analizando el Estado de Verificación de BD Local",
        modalDescription_second: "Sus fincas están siendo sometidas a un Análisis Automatizado de Verificación de BD Local. Será redirigido a la página de la lista de Informes de Diligencia Debida para ver el estado.",
      },
      enableAutomaticRiskMitigation: "Habilitar Mitigación Automática de Riesgos",
      enableAutomaticRiskMitigationInfo: "Cuando está habilitado, las fincas con un estado de deforestación de 'Riesgo Detectado' se mitigarán automáticamente sin intervención manual.",
      unregistered: "No Registrado",
      registered: "Registrado",
      circularGeofenceWithAreaGreaterThan4HA: "Geocerca circular con un área mayor a 4 ha",
      pendingOrNewlyReceived: "Pendiente / Recién Recibido",
      overdue: "Vencido",
      waitingForPayment: "Esperando Pago",
      paymentPendingVerificationStatus: "Pago Pendiente de Verificación",
      approvalStatus: "Estado de Aprobación",
      temporaryApproved: "Procesando Aprobación",
      shipmentInProcess: "Envío en Proceso",
      exporterAlreadyAdded: "Este exportador ya ha sido agregado",
      addExporter: "Agregar Exportador",
      addedExporters: "Exportadores Agregados",
      exporterMandatoryNote: "(Se requiere al menos un exportador)",
      removeExporter: "Eliminar exportador",
      enterExporterEmailKenya: "Ingrese el correo electrónico del agente",
      shareReportKenya: "Compartir Informe con el Agente",
      exporterInformationKenya: "Información del Agente",
      selectUserToAssign: "Seleccionar Usuario para Asignar",
      pleaseEnterExporterEmailKenya: "Por favor, ingrese el correo electrónico del agente",

  },


  containerTypes: {
    standardDry: "Contenedor Seco Estándar (20ft, 40ft)",
    highCube: "Contenedor de Cubo Alto",
    openTop: "Contenedor Abierto",
    flatRack: "Contenedor de Bastidor Plano",
    refrigerated: "Contenedor Refrigerado (Reefer)",
    tank: "Contenedor de Tanque",
    ventilated: "Contenedor Ventilado",
    insulated: "Contenedor Aislado",
    platform: "Contenedor de Plataforma",
    halfHeight: "Contenedor de Media Altura",
    bulk: "Contenedor a Granel"
  },

  dueDiligence: {
    showFarmWithIssues: "Mostrar granjas con problemas",
    question: "Pregunta",
    answer: "Respuesta",
    comments: "Comentarios",
    "commentsRegardingStatement": "Comentarios sobre la declaración",
    enableRiskWarnings: "Habilitar advertencias de riesgo en pantalla",
    doYouWantToSendToOperator: "¿Quieres enviar este informe al operador?",
    countryOfProduction: "País de Producción",
    countryOfProductionTT: "País de Producción",
    containerId:"Id. de contenedor",
    createWithoutRiskAssessment: {
      title: "Crear DDS sin evaluación personalizada",
      message: "¿Desea crear un DDS sin agregar una evaluación personalizada? Si es así, las reglas de verificación de cumplimiento omitirán este paso.",
      confirmBtnText: "Sí",
      cancelBtnText: "No",
      doNotShowAgain: "No volver a mostrar este mensaje"
    },
    noAssessmentWarning: "Faltan las evaluaciones de riesgo en el informe DDS.",
    disputeReason: "Por favor, elija un motivo de disputa.",
    agricultureAgreement: "Por favor, acepte el término antes de continuar.",
    attachDisputeFile: "Por favor, adjunte un archivo antes de presentar la disputa.",
    listOfFarmsInfo:"Una visualización completa de las fincas, que incluye información como la ubicación de producción, el nombre del productor, el país de operación, el área de tierra en hectáreas, el tipo de actividades agrícolas, evaluaciones relacionadas con la deforestación y evaluaciones de riesgos potenciales asociados con las operaciones agrícolas",
    producerTT: "Selección de productores o fabricantes involucrados en la cadena de suministro.",  
    supplierInformationTT: "Detalles sobre la entidad que proporciona bienes o servicios.",
    operatorTooltip: "Seleccione el operador de la lista pre-registrada en el sistema",
    operatorSelect: "Operador: Elija esta opción si usted, como operador, será responsable de agregar datos de lugar de producción. Tendrá la opción de proporcionar una lista de productores, sus granjas y las geolocalizaciones dentro de la aplicación.",  
    supplierSelect: "Proveedor: Elija esta opción si el proveedor será responsable de agregar datos de lugar de producción. Tendrán acceso para proporcionar la lista de productores, sus granjas y las geolocalizaciones directamente dentro de la aplicación.", 
    selectWhoWillAddPlaceData: "Seleccione quién agregará los datos del lugar de producción",
    supplierTooltip: "Seleccione el proveedor de la lista pre-registrada en el sistema.",
    requiredAssessmentTooltip: "Elegir información de evaluación necesaria.",
    internalRefNoTooltip: "Un identificador único asignado dentro de una organización o sistema para hacer referencia a datos, transacciones o registros específicos con fines de seguimiento y gestión internos.", 
    eudrRefNoTooltip: "Se refiere a un identificador único asociado con el Reglamento de Deforestación de la Unión Europea (EUDR), generalmente utilizado para rastrear y hacer referencia a información relacionada con el cumplimiento en el contexto de las regulaciones de deforestación.",  
    companyIdTooltip: "Un identificador distinto asignado a una empresa u organización con fines de identificación y seguimiento, a menudo utilizado dentro de sistemas, bases de datos o marcos regulatorios.", 
    placeOfActivityTooltip:"Especifique el país del operador donde se realizan las actividades y el país donde el producto ingresará al mercado de la UE. Estos detalles son esenciales para el cumplimiento preciso de los requisitos de EUDR.",  
    productDetailToolTip:"Proporciona información detallada sobre el producto, incluido su nombre, masa neta, volumen, nombre científico y nombre común.",
    productToolTip: "Nombre del producto. Se refiere a un artículo o mercancía tangible producido, fabricado o comercializado por una empresa",
    productDescToolTip: "Proporciona una explicación o resumen textual de las características, funciones o atributos de un producto, con el objetivo de informar a los usuarios o clientes sobre su naturaleza o funcionalidad.",  
    subProductToolTip: "Nombre del Sub - Producto. Denota una categoría o subconjunto específico de una categoría de producto más grande, generalmente utilizado para una clasificación o diferenciación adicional dentro de una jerarquía de productos.", 
    netMassTooltTip: "Indica el peso de un producto o artículo, generalmente excluyendo el peso del embalaje u otros materiales asociados, a menudo expresado en unidades de masa como kilogramos o libras.",
    volumeToolTip: "Se refiere a la cantidad de espacio ocupado por un producto o sustancia, generalmente medido en unidades cúbicas como metros cúbicos o pies cúbicos, utilizado para cuantificar la capacidad o cantidad en el espacio tridimensional.",  
    scietificNameToolTip: "Nombre taxonómico de un organismo que consta del género y la especie, por ejemplo, Coffea Arabica, Theobroma cacao L.", 
    commonNameToolTip: "Un nombre que se basa en el lenguaje normal de la vida cotidiana, por ejemplo, Cacao, Café.",
    manaulProductionPlaceTooltip: "Proceso de ingreso manual de ubicaciones de fabricación en el sistema.",
    producerNameTT: "El nombre de un individuo / empresa / organización que crea y suministra bienes o servicios",
    producerCountryTT: "La nación de origen de donde proviene el productor",
  
    productionPlaceUsingLots:'Seleccionar Lugares de Producción utilizando Lotes',
    dueDiligence: "Debida Diligencia EUDR",
    assementBuilder: "Constructor de Evaluaciones",
    assessment: "Evaluación",
    assessmentsList: "Lista de Evaluaciones",
    noOfFarmResponses: "N.º de respuestas de fincas",
    createAssessment: "Crear Evaluación",
    assessmentName: "Nombre de la Evaluación",
    assessmentNameInfo: "Funcionalidad para encontrar evaluaciones o información específica.",
    searchAssessment: "Buscar Evaluación",
    selectProcess: "Seleccionar Proceso de Evaluación",
    assessSettings: "Configuración de Evaluación",
    assessmentTitle: "Título de la Evaluación",
    assessmentTitleInfo: "Nombre que identifica una evaluación.",
    assessDescription: "Descripción de la Evaluación",
    assessDescriptionInfo: "Breve explicación del propósito o contenido de la evaluación.",
    describeAsessment: "Describir la Evaluación",
    selectCountry: "Seleccionar País",
    expiryTime: "Tiempo de Expiración",
    expiryTimeInfo: "Duración hasta que la evaluación caduque o se vuelva inválida.",
    noQuestionEachStep: "Número de preguntas",
    byHeadings: "Por Encabezados",
    assessmentStatus: "Estado de la Evaluación",
    multiStepAssess: "Evaluación de Múltiples Pasos",
    allowAssessment: "Permitir que la evaluación sea respondida más de una vez",
    onlyIfExpired: "Solo si está Expirada",
    atAnyTime: "En Cualquier Momento",
    editAssessmentDetails: "Editar Pregunta de Evaluación",
    assessmentDetail: "Detalles de la Evaluación",
    addQuestion: "Agregar Pregunta de Evaluación",
    attachFiles: "Adjuntar Archivos",
    digitalSignature: "Firma Digital",
    showChecklist: "Mostrar Lista de Verificación",
    hideChecklist: "Ocultar Lista de Verificación",
    fileType: "Tipo de Archivo",
    allowMultipleFile: "Permitir Múltiples Adjuntos",
    allowComment: "Permitir Comentarios",
    uploadSignatureFile: "Cargar Archivo de Firma",
    drawSignature: "Dibujar Firma",
    addSubHeading: "Agregar Sub-Encabezado",
    editSubHeading: "Editar subtítulo",
    heading: "Encabezado",
    headingInfo: "Encabezado bajo el cual se categorizará la pregunta de la evaluación. Un menú desplegable para seleccionar el encabezado.",
    headingTitle: "Título del encabezado",
    subHeading: "Sub-Encabezado",
    dueDiligenceReports: "Informes de Debida Diligencia",
    logistics: "Logística",
    partOfOrigin: "Puerto de Origen",
    destination: "Puerto de Destino",
    addStop: "Añadir una Parada",
    stop: "Parada",
    enterStop: "Ingresar Parada",
    manageFarms: "Gestionar Granjas",
    disputeResolution: "Resolución de Disputas",
    suppliers: "Proveedores",
    shipments: "Envíos",
    dueDiligenceGuide: "Guía de Debida Diligencia",

    // Activity Log translations
    activityLog: "Registro de actividad",
    activityLogTT: "Registro de acciones realizadas en este informe.",
    user: "Usuario",
    userRole: "Rol del usuario",
    ipAddress: "Dirección IP",
    segment: "Segmento",
    activityDescription: "Descripción de la actividad",

    selectRequiredAssessment: "Seleccionar Evaluaciones Requeridas",
    filterAssessments: "Filtrar Evaluaciones",
    dueDiligenceReportCreation: "Creación de Informes de Debida Diligencia",
    dueDiligenceNew: "Debida Diligencia",

    createNewReport: "Crear Nuevo Informe",
    operator: "Operador",
    supplier: "Proveedor",
    addMoreAssessments: "Agregar Más Evaluaciones",
    internalReferenceNumber: "Número de Referencia Interno",
    referenceNumber: "Número de Referencia",
    domestic: "Doméstico",
    import: "Importación",
    export: "Exportación",
    selectProduct: "Seleccionar Producto",
    selectSubProduct: "Seleccionar Sub Producto",
    addnewSupplier: "Agregar Nuevo Proveedor",
    farmDeforestationReport: "Informe de Deforestación de la Finca",

    addProductionPlaceData: "Agregar Datos del Lugar de Producción",
    addProductionPlaceDataTooltip: "Elige cómo deseas agregar datos",
    addProductionPlaceDataDesc:
      "Crea tus informes integrando datos de producción de diversas fuentes. Selecciona una o varias fuentes para compilar una lista completa de lugares de producción para tus informes.",
    dimitraApps: "Aplicaciones Dimitra",
    addNew: "Agregar Nuevo",
    existingData: "Datos Existentes",
    manualDataEntry: "Entrada Manual de Datos",
    importFile: "Importar Archivo",
    connectedCoffee: "Café Conectado",
    connectedCacao: "Cacao Conectado",
    connectedFarmer: "Agricultor Conectado",
    manaulProductionPlace: "Entrada Manual de Lugares de Producción",
    farmerRegistrationId: "ID de Registro del Agricultor", 
    farmRegistrationId: "ID de Registro de la Finca",
    addProductionPlace: "Agregar Lugar de Producción",
    producerName: "Nombre del Productor",
    producerCountry: "País del Productor",
    totalArea: "Área Total (ha)",
    number: "Número",
    productionPlaceDesc: "Descripción del Lugar de Producción",
    area: "Área",
    type: "Tipo",
    actions: "Acciones",
    selectType: "Seleccionar Tipo",
    importProductionPlace: "Importar Lugar de Producción",
    downloadCSVFormat: "Descargar como Formato CSV",
    downloadXLSFormat: "Descargar Formato XLS",
    downloadGeoJsonFormat: "Descargar Formato GeoJSON",
    downloadXMLFormat: "Descargar Formato XML",
    downloadFileFormatTemplates: "Descargar Plantillas de Formato de Archivo",
    importantNote: "Nota Importante",
    pleaseProvideFollowing:
      "Por favor, proporcione el siguiente formato (GeoJSON y XML)",
    existingProductionPlaces: "Lugares de Producción Existentes",
    productionPlaceAndFarmID: "Lugar de Producción y ID de Finca",
    selectFileToUploadData: "Seleccionar archivo para cargar los datos",
    filterByDate: "Filtrar por fecha",
    dateOfRegister: "Fecha de registro",
    dateOfLastReport: "Fecha del último informe",
    clearAll: "Limpiar todo",
    addLocation: "Agregar ubicación",

    "pleaseCompleteBeforeProceedingToNext": "Por favor complete la sección de detalles del informe antes de proceder al siguiente paso.",
    "progressSavedSuccessMsg": "¡Progreso guardado con éxito!",
    "failedSavedProgress": "No se pudo guardar el progreso. Por favor, inténtelo de nuevo.",
    "savingProgress": "Guardando su progreso...",
    "progressSaved": "Progreso guardado. Puede continuar este informe más tarde desde la lista de informes.",
    "failedToCreateReportDetails": "No se pudo crear ReportDetails. Por favor, inténtelo de nuevo.",
    "unExpectedErrorMsg": "Ocurrió un error inesperado. Por favor, inténtelo de nuevo.",
    "selectAssessment": "Seleccionar Evaluación",
    "confirmationPopup": "Ventana de Confirmación",
    "confirmationPopupMsg": "¿Está seguro de que desea descartar este informe? Confirmar esta acción resultará en la eliminación permanente.",
    "supplierNotRegisterContent": "El proveedor no está registrado. ¿Desea enviar una notificación al proveedor para que se una a la plataforma por correo electrónico?",

    "warningPopup": "Ventana de Advertencia",
    "warningPopupMsg": "¿Está seguro de que desea rechazar este informe? Nota: Los datos de este informe se guardarán después del rechazo en caso de que desee revisarlo más tarde.",
    "automatedDeforestationProgressText": "Verificación automatizada de deforestación de datos de geovalla e identificación de casos críticos",
    "someRiskWereIdentifiedText": "Se identificaron algunos riesgos en la siguiente granja, debe revisar la granja con los riesgos identificados y mitigarlos antes de pasar al siguiente paso.",
    "riskAssessmentAndMitigation": "Evaluación y Mitigación de Riesgos",
    "riskAssessmentStatus": "Estado de Evaluación de Riesgos",
    "riskAssessment": "Evaluación de Riesgos",
    "uploadRiskAssessment": "Subir Evaluación de Riesgos",
    uploadRiskAssessmentTT: "Acción para subir un documento de evaluación de riesgos.",
    "manualFillOutAssessment": "Rellenar evaluación manualmente",
    manualFillOutAssessmentTT: "Acción para completar un formulario de evaluación manualmente.",
    criteria : "Criterios (b, f y g)",
    "downloadAssessmentForm": "Descargar Formulario de Evaluación",
    "addSignature": "Agregar Firma",
    uploadImage: "Subir Imagen",
    "createNewDueDiligenceProgress": "Crear Nuevo Proceso de Debida Diligencia",
    "usageLimits": "Límites de Uso",
    "totalReports": "Total de Informes",
    "eudrDeforestationAssessments": "Evaluaciones de Deforestación EUDR",
    "totalAssessments": "Total de Evaluaciones",
    "listOfFarms": "Lista de Granjas",
    "perMonth": "Por Mes",
    "share": "Compartir",
    "viewReport": "Ver Informe",
    "viewReportSummary": "Ver resumen del informe",
    "copy": "Copiar",
    "copyAndCreateNew": "Copiar y Crear Nuevo",
    "listOfSupplier": "Lista de Proveedores",
    "addNewSupplier": "Agregar nuevos proveedores",
    "editSupplier": "Editar Proveedor",
    "supplierName": "Nombre del Proveedor",
    "listOfOperators": "Lista de Operadores",
    "addNewOperator": "Agregar nuevos operadores",
    "operatorName": "Nombre del Operador",
    "operators": "Operadores",
    "editOperator": "Editar Operador",
    "eoriNumber": "Número EORI",
    "enterEmailAddress": "Ingrese la dirección de correo electrónico",
    "enterFirstName": "Ingrese el nombre",
    "enterLastName": "Ingrese el apellido",
    "enterEORINumber": "Ingrese el número EORI",
    "myFarms": "Mis Granjas",
    "listOfProducers": "Lista de Productores",
    "producers": "Productores",
    "addNewProducer": "Agregar Nuevo Productor",
    "lastAssessment": "Última Evaluación",
    "noOfFarms": "Número de Granjas",
    "shipmentID": "ID de Envío",
    "shipmentList": "Lista de Envíos",
    "createShipment": "Crear nuevo envío",
    "noOfReports": "N.º de Informes",
    confirmation: "Confirmación",
    saveAndConfirmationMessage:"¿Estás seguro de que deseas guardar los cambios?",
    confirmDownload: "¿Desea descargar todos los archivos adjuntos en formato PDF?",

    selectProductionPlacesUsingLots: "Seleccione los lugares de producción utilizando lotes",
    SelectProductionPlacesUsingFarms: "Seleccione los lugares de producción utilizando granjas",

    areaForPointGeofence: "Área para geocerca circular",
    accordingToEUDRFarmsWithLessThan4HectaresDoNotRequireAPolygon: "Según EUDR, las granjas con menos de 4 hectáreas no requieren un polígono.",
    circularAreaEquivalent:  "En estos casos, utilizaremos un área circular equivalente al tamaño de la finca, con el punto GPS proporcionado como centro para verificar la deforestación. Cuando no se proporcione el tamaño de la finca, utilizaremos 4 hectáreas de forma predeterminada.", 
    ifTheFarmsAreSmallerPleaseEnterTheStandardSizeInTheFieldBelow: "Si las granjas son más pequeñas, ingrese el tamaño estándar en el campo a continuación.",
    defaultCircularGeofence: "Las granjas sin geocerca o sin información sobre su tamaño se asignarán una geocerca circular predeterminada de 4 hectáreas. Si el tamaño promedio de la finca es menor a 4 hectáreas, cambie el tamaño predeterminado haciendo clic en el botón 'Editar' a continuación.", 
    defaultAreaValueSpecified: "Las granjas sin geocerca o área recibirán el valor de área predeterminado especificado a continuación y se les asignará una geocerca circular con un radio circular." ,
    uploadFileBeingProcessed: "Sus archivos cargados se están procesando. Será redirigido a la página de lista de informes de debida diligencia para ver el estado.",
    processingLocations: "Procesando Ubicaciones",

    lotId: "ID de Lote",
    lotIds: "ID de Lotes",
    product:"Producto",
    qualityGade: "Grado de Calidad",
    processingDate: "Fecha de Procesamiento",   

    importProductionPlaceTT: "Permite a los usuarios importar datos de lugar de producción utilizando opciones de carga o descarga de archivos.",  
    internalReferenceNumberTT: "Un número de referencia o código utilizado internamente para organizar y gestionar informes de debida diligencia.",

    onlyShowFarmsWithIssues: "Mostrar solo granjas con problemas",

    analyzingStatus: "Analizando el Estado de Deforestación",
    readyToProceed: "Listo para Continuar",
    mitigationRequired: "Mitigación Requerida",
    viewSummary: "Ver Resumen",
    viewAssessment: "Ver Evaluación",
    disputes: "Disputas",
    manualRiskMitigation: "Mitigación Manual de Riesgo",
    veryHighProbability: "Muy Alta Probabilidad",
    highProbability: "Alta Probabilidad",
    mediumProbability: "Probabilidad Media",
    lowProbability: "Baja Probabilidad",
    veryLowProbability: "Muy Baja Probabilidad",
    zeroProbability: "Cero/Nula Probabilidad",
    manualMitigated: "Mitigado Manualmente",
    disputeDesc: "Haz clic en una de las disputas a continuación para ver más detalles.",
    geofenceColorCode: "Código de Color del Geofence:",
    noDisputeHaveSubmitted: "No se ha enviado ninguna disputa aún",
    disputeDetails: "Detalles de la Disputa",
    chooseDisputeReason: "Selecciona el Motivo de la Disputa",
    pleaseAttachDoc: "Por favor adjunta documentos/fotos para apoyar tu respuesta.",
    additionalNotes: "Notas Adicionales",
    aggrementStatement: "Entiendo que la tierra afectada no se utilizará para agricultura en los próximos años.",
    addGeofenceRadius: "Añadir Radio de Geofence",
    totalGeofenceRadius: "El Radio Total del Geofence es",
    resolutionHistory: "Historial de Resolución",
    proceed: "Continuar",
    wildFire: "Incendio Forestal",
    controlledFire: "Incendio Controlado",
    clearingForAgriculture: "Despeje para Agricultura y/o Ganadería",
    pestAndDiseases: "Plagas y Enfermedades",
    naturalChangesInCanopy: "Cambios Naturales en el Dosel (como caída de hojas estacional)",
    strongWinds: "Vientos Fuertes (como huracanes o tornados)",
    otherNaturalDisasters: "Otros Desastres Naturales",
    flooding: "Inundaciones",
    logging: "Tala de Bosques",
    infrastructure: "Infraestructura",
    urbanization: "Urbanización",
    landGrabbingOrPopulationPressure: "Despojo de Tierra, Agricultura de Subsistencia o Presión Poblacional",
    mining: "Minería",
    plantationForestBeforeDeadline: "Es un bosque de plantación o una tierra arborizada, pero los bosques primarios o los bosques naturalmente regenerados se convirtieron en bosques de plantación o en otras tierras arborizadas antes de la fecha límite (31 de diciembre de 2020)",
    convertedToPlantationForest: "Los bosques primarios o los bosques naturalmente regenerados se convirtieron en bosques de plantación o en otras tierras arborizadas",
    cultivatedAreaBeforeDeadline: "Es un área cultivada y no fue deforestada después de la fecha límite (31 de diciembre de 2020)",
    forestStillPreserved: "Hay un bosque en el área, pero no fue deforestado y todavía está preservado",
    downloadAsPDF: "Descargar como PDF",
    downloadAsJSON: "Descargar como JSON",
    downloadOptions: "Opciones de Descarga",
    productionPlacesHighDeforestationProbability: "Los lugares de producción tienen alta probabilidad de deforestación",
    geofenceHighDeforestationProbability: "El Geofence tiene alta probabilidad de deforestación",
    EUDRReferenceNumber: "Número de Referencia del EUDR",
    commonName: "Nombre Común",
    totalNoOfRiskAssessment: "Número Total de Evaluaciones de Riesgo",
    totalNoOfHighDeforestation: "Número Total de Fincas con Alta Probabilidad de Deforestación",
    totalNoOFDeforestationAssessments: "Número Total de Evaluaciones de Deforestación",
    totalNoOfFarms: "Número Total de Fincas",
    totalNoOfGeofencePoints: "Número Total de Puntos de Geofence",
    totalNoOfGeofencePolygons: "Número Total de Polígonos de Geofence",
    reportSummary: "Resumen del Informe",
    supplierData: "Datos del Proveedor",
    isoCode: "Código ISO",
    operatorData: "Datos del Operador",
    dueDiligenceReportStatus: "Estado del Informe de Diligencia Debida",
    declarationStatement: "Declaración del Operador",
    undoDelete: "Deshacer Eliminación",
    analyzingDeforestation: "Analizando la Deforestación",
    processingFarm: "Procesando Finca",
    supplierTT: "Selección de proveedores o fabricantes involucrados en la cadena de suministro.",
    pleaseSelectAtLeastOneItem: "Por favor selecciona al menos un elemento.",
    
    pleaseSelectAtLeastOneSource: "Por favor seleccione al menos una fuente.",
    invalidFileFormatPleaseUploadValidFile: "Formato de archivo no válido. Por favor cargue un archivo .xml, .kml o .geojson.",
    pleaseUploadAValidFile: "Por favor cargue un archivo válido.",
    fileUploadedDuccessfully: "¡Archivo cargado con éxito!",
    anErrorOccured: "Ocurrió un error.",
    successfullyUpdatedDefaultFarmArea: "Área de granja predeterminada actualizada con éxito.",
    pleaseAddProductionPlacesData: "Por favor agregue los datos de los lugares de producción.",
    failedToFetchSettings: "No se pueden obtener las configuraciones. Por favor, revise sus configuraciones o contacte con soporte si el problema persiste.",
    updatedDueDiligenceReport: "Informe de diligencia debida actualizado.",
    updatedDueDiligenceStatus: "El estado de la Diligencia Debida se ha actualizado correctamente.",
    failedToWriteDeforestationDataToBlockchain: "Error al escribir los datos de deforestación en la cadena de bloques, por favor intente nuevamente.",

    mutiStepHeadingLable: "Cree una nueva etapa para cada sub-título",
    multiStepQuestion1: "Cree un nuevo paso despues de",
    questions: "preguntas",
    questionsInfo: "Cantidad de preguntas en cada etapa de una evaluación de varios pasos.",
    countryIsRequired: "País es requerido", 
    

    dueDiligenceReportsInfo: "Documentación detallada que resume los hallazgos y resultados del proceso de debida diligencia. Estos informes proporcionan información sobre la evaluación realizada, incluidos los riesgos identificados, el estado de cumplimiento y las recomendaciones para la mitigación o mejora.",
    listOfFarmsTT: "Una visualización completa de las granjas, incluida información como la ubicación de producción, el nombre del productor, el país de operación, el área de tierra en hectáreas, el tipo de actividades agrícolas, evaluaciones relacionadas con la deforestación y evaluaciones de los riesgos potenciales asociados con las operaciones de la granja.",
    existingProductionPlacesTT: "Muestra una lista de lugares de producción existentes junto con detalles como el nombre del productor, país, área, tipo y estado de evaluación.",
    loadingPleaseWait: "Cargando... Por favor espere",
    analyzingDesc: "Tus granjas están siendo sometidas a un Análisis Automatizado de Deforestación. Serás redirigido a la página de la lista de Informes de Diligencia Debida para ver el estado.",
    successfullyGeneratedEUDRDeforestationStatus: "Se generó correctamente el estado de deforestación de EUDR.",
    riskAssessmentAndMitigationTT: "Identificar riesgos potenciales e implementar estrategias para minimizar su impacto o probabilidad de ocurrencia. Incluye evaluar peligros, analizar sus posibles consecuencias y desarrollar planes para abordarlos o mitigarlos de manera efectiva.",
    
    eudrRefNoTT: "Un identificador único asignado a cada informe de diligencia debida, que facilita el seguimiento y la verificación de cumplimiento dentro del marco del Reglamento de Deforestación de la Unión Europea (EUDR)." ,

    operatorDataTT: "Información sobre el operador.",
    supplierDataTT: "Información sobre el proveedor.",
    reportSummaryTT: "Descripción breve del informe.",
    totalNoOfGeofencePolygon: "Número Total de Polígonos de Geocerca",
    totalNoOfGeofencePolygonTT: "Conteo total de polígonos de geocerca.",
    totalNoOfGeofencePoint: "Número Total de Puntos de Geocerca",
    totalNoOfGeofencePointTT: "Conteo total de puntos de geocerca.",
    totalNoOfFarmsTT: "Conteo total de granjas.",
    totalAreaFinalReport: "Área Total (ha)",
    totalNoOfDeforestationTT: "Conteo total de evaluaciones de deforestación.",
    totalNoOfHighDeforestationTT: "Conteo total de granjas con alta deforestación.",
    totalNoOfRiskAssessments: "Número Total de Evaluaciones de Riesgo",
    totalNoOfRiskAssessmentsTT: "Conteo total de evaluaciones de riesgo.",
    productDetail: "Detalles del Producto",
    productDetailTT: "Información sobre el producto.",
    productTT: "Nombre del producto. Se refiere a un artículo tangible o mercancía producida, fabricada o comercializada por una empresa u organización, a menudo categorizada según su tipo, características o propósito.",
    productDescription: "Descripción del Producto",
    productDescriptionTT: "Proporciona una explicación o resumen textual de las características, funciones o atributos de un producto, con el objetivo de informar a los usuarios o clientes sobre su naturaleza o funcionalidad.",
    netMass: "Masa Neta",
    netMassTT: "Indica el peso de un producto o artículo, normalmente excluyendo el peso del embalaje u otros materiales asociados, a menudo expresado en unidades de masa como kilogramos o libras.",
    volume: "Volumen",
    volumeTT: "Se refiere a la cantidad de espacio que ocupa un producto o sustancia, generalmente medido en unidades cúbicas como metros cúbicos o pies cúbicos, utilizado para cuantificar la capacidad o cantidad en el espacio tridimensional.",
    scientificName: "Nombre Científico",
    scientificNameTT: "Nombre taxonómico de un organismo que consta del género y la especie, por ejemplo, Coffea Arabica, Theobroma cacao L.",
    commonNameTT: "Un nombre basado en el lenguaje común de la vida cotidiana, por ejemplo, Cacao, Café.",

    successfullyUploadedToTheBlockchain: "¡Éxito! El Informe de Diligencia Debida de EUDR se ha subido con éxito a la Blockchain.",
    complianceRiskWarning: "Advertencia de Riesgo de Cumplimiento",
    issueIdentifiedOnFarms: "Se han identificado problemas en algunas granjas que necesitan atención antes de proceder al siguiente paso. Puede elegir abordar estos problemas ahora o continuar al siguiente paso y resolverlos más tarde.",
    blockchainDescs: [
      'Subiendo informe a blockchain, por favor espera...',
      'Su informe de Diligencia Debida se está subiendo a blockchain. Será redirigido a la página de lista de Informes de Diligencia Debida para ver el estado.'
    ],
    reportDownloadedSuccessfully: "¡Éxito! El Informe de Diligencia Debida de EUDR se ha descargado con éxito.",
    operatorDecleration: "Declaración del Operador",
    supplierDecleration: "Declaración del Proveedor",
    fRinternalReferenceNumberTT: "Un número de referencia interno es un identificador único asignado a un informe de diligencia debida dentro del sistema.",
    deleteProductionPlaceData: "Eliminar Datos del Lugar de Producción",
    areYouSureYouWantToContinueThisAction: "¿Estás seguro de que deseas continuar con esta acción?",
    noAssessment: "Sin evaluación",
    
    uploadingToBlockchain: "Cargando informe en la blockchain, por favor, espere...",
    beingUploadToBlockChain: "Su informe de Diligencia Debida se está cargando en la blockchain. Serás redirigido a la página de lista de Informes de Diligencia Debida para ver el estado.",
    uploading: "Cargando",
    attachFile: "Adjuntar Archivo",
    close: "Cerrar",
    status: "Estado",
    lotID: "ID de Lote",
    noOfFarm: "No. de Granjas",
    origin: "Origen",
    selectUsingLots: "Seleccionar Lugares de Producción Usando Lotes",
    productionPlaceUsingFarms: "Seleccionar Lugares de Producción Usando Granjas",
    searchFarmName: "Buscar nombre de granja",
    viewLocation: "Ver Geolocalización",
  
    selectStatus: "Seleccionar Estado",
    netMassKG: "Masa Neta (kg)",
    volumeM3: "Volumen (m³)",
    volumeM: "Volumen",
    areaInHA: "Área (ha)",
    eudrUploadedToBlockChain: "¡Éxito! El Informe de Diligencia Debida EUDR se ha cargado con éxito en la Blockchain.",
    viewDeforestationAssessment: "Ver Evaluación de Deforestación",
    viewDeforestationCertificate: "Ver Certificado de Deforestación",
    selectCountries: "Seleccionar Países",
    writingToBlockchain: "Escribiendo en la Blockchain",
    

    compilanceRiskWarning: "Advertencia de Riesgo de Cumplimiento",
    operatorDeclerationTT: "Declaración de declaración del operador.",
    supplierDeclerationTT: "Declaración de declaración del proveedor.",




    cattle: "Ganado",
    cocoa: "Cacao",
    "coffee": "Café",
    "wood": "Madera",
    "soya": "Soja",
    "rubber": "Caucho",
    oilPlam: "Palma de aceite",
    
    subProduct1: "0102 21 , 0102 29 Bovinos vivos",
    subProduct2: "0201 Carne de bovino, fresca o refrigerada",
    subProduct3: "0202 Carne de bovino, congelada",
    subProduct4: "0206 10 Despojos comestibles de bovino, frescos o refrigerados",
    subProduct5: "0206 22 Hígados comestibles de bovino, congelados",
    subProduct6: "0206 29 Despojos comestibles de bovino (excepto lenguas e hígados), congelados",
    subProduct7: "1602 50 Las demás preparaciones y conservas de carne, despojos y sangre de bovino",
    subProduct8: "4101 Cueros y pieles, en bruto, de ganado vacuno (frescos o salados, secos, encalados, piquelados o conservados de otro modo, pero sin curtir, apergaminar ni preparar de otra forma), incluso depilados o divididos",
    subProduct9: "4104 Cueros y pieles de vacuno depilados, curtidos o crust, incluso divididos, pero sin otra preparación",
    subProduct10: "4107 Cueros de vacuno preparados después del curtido o del secado, incluidos los cueros apergaminados, depilados, incluso divididos, excepto los cueros de la partida 4114",
    subProduct11: "1801 Cacao en grano, entero o partido, crudo o tostado",
    subProduct12: "1802 Cáscaras, cáscaras, pieles y demás desperdicios de cacao",
    subProduct13: "1803 Pasta de cacao, incluso desgrasada",
    subProduct14: "1804 Manteca, grasa y aceite de cacao",
    subProduct15: "1805 Cacao en polvo, sin adición de azúcar ni otro edulcorante",
    subProduct16: "1806 Chocolate y demás preparaciones alimenticias que contengan cacao.",
    subProduct17: "0901 Café, incluso tostado o descafeinado; cáscaras y pieles de café; sucedáneos del café que contienen café en cualquier proporción",
    subProduct18: "1207 10 Nueces y pepitas de palma",
    subProduct19: "1511 Aceite de palma y sus fracciones, incluso refinado, pero sin modificar químicamente",
    subProduct20: "1513 21 Aceites de palmiste y de babasú, en bruto, y sus fracciones, incluso refinados, pero sin modificar químicamente",
    subProduct21: "1513 29 Aceites de palmiste y de babasú y sus fracciones, incluso refinados, pero sin modificar químicamente (excepto el petróleo crudo)",
    subProduct22: "2306 60 Tortas y demás residuos sólidos de nueces o almendras de palma, incluso molidos o en pellets, resultantes de la extracción de grasas o aceites de nueces o almendras de palma",
    subProduct23: "2905 45 Glicerol, con una pureza igual o superior al 95 % (calculada sobre el peso del producto seco)",
    subProduct24: "2915 70 Ácido palmítico, ácido esteárico, sus sales y ésteres",
    subProduct25: "2915 90 Ácidos monocarboxílicos acíclicos saturados, sus anhídridos, halogenuros, peróxidos y peroxiácidos; sus derivados halogenados, sulfonados, nitrados o nitrosados ​​(excepto ácido fórmico, ácido acético, ácido mono, di o tricloroacético, ácido propiónico, ácido butanoico, ácido pentanoico, ácido palmítico, ácido esteárico, sus sales y ésteres y anhídrido acético)",
    subProduct26: "3823 11 Ácido esteárico, industrial",
    subProduct27: "3823 12 Ácido oleico, industrial",
    subProduct28: "3823 19 Ácidos grasos monocarboxílicos industriales; Aceites ácidos procedentes del refinado (excepto ácido esteárico, ácido oleico y ácidos grasos de tall oil)",
    subProduct29: "3823 70 Alcoholes grasos industriales",
    subProduct30: "4001 Caucho natural, balata, gutapercha, guayule, chicle y gomas naturales similares, en formas primarias o en placas, láminas o tiras.",
    subProduct31: "4005 Caucho compuesto, sin vulcanizar, en formas primarias o en placas, hojas o tiras",
    subProduct32: "4006 Caucho sin vulcanizar en otras formas (por ejemplo, varillas, tubos y perfiles) y artículos (por ejemplo, discos y anillos)",
    subProduct33: "4007 Hilos y cordones de caucho vulcanizado",
    subProduct34: "4008 Placas, láminas, tiras, varillas y perfiles, de caucho vulcanizado sin endurecer",
    subProduct35: "4010 Correas o correas transportadoras o de transmisión, de caucho vulcanizado",
    subProduct36: "4011 Neumáticos nuevos de caucho",
    subProduct37: "4012 Llantas neumáticas de caucho recauchutadas o usadas; neumáticos macizos o acolchados, bandas de rodadura y faldones para neumáticos, de caucho",
    subProduct38: "4013 Cámaras de aire, de caucho",
    subProduct39: "4015 Prendas y complementos (incluidos guantes, manoplas y manoplas), para todos los usos, de caucho vulcanizado sin endurecer",
    subProduct40: "4016 Las demás manufacturas de caucho vulcanizado sin endurecer, no expresadas en otra parte del capítulo 40",
    subProduct41: "4017 Caucho duro (por ejemplo, ebonita) en todas sus formas, incluidos desperdicios y desechos; manufacturas de caucho endurecido",
    subProduct42: "1201 Habas de soja, incluso quebrantadas",
    subProduct43: "1208 10 Harina y sémola de soja",
    subProduct44: "1507 Aceite de soja y sus fracciones, incluso refinado, pero sin modificar químicamente",
    subProduct45: "2304 Tortas y demás residuos sólidos de la extracción del aceite de soja, incluso triturados o en pellets.",
    subProduct46: "4401 Leña para combustible, en rollizos, tochos, ramitas, leños o formas similares; madera en astillas o partículas; aserrín, desperdicios y desechos de madera, incluso aglomerados en leños, briquetas, pellets o formas similares",
    subProduct47: "4402 Carbón vegetal (incluido el carbón vegetal de cáscaras o de nueces), incluso aglomerado",
    subProduct48: "4403 Madera en bruto, incluso descortezada o alburada, o escuadrada",
    subProduct49: "4404 Aro de madera; postes divididos; pilotes, estacas y estacas de madera, puntiagudas pero sin aserrar longitudinalmente; palos de madera, desbastados pero sin tornear, curvar ni trabajar de otro modo, aptos para la fabricación de bastones, paraguas, mangos de herramientas o artículos similares; madera astillada y similares",
    subProduct50: "4405 Lana de madera; harina de madera",
    subProduct51: "4406 Traviesas (traviesas) de madera para vías férreas o tranvías",
    subProduct52: "4407 Madera aserrada o desbastada longitudinalmente, cortada o desenrollada, incluso cepillada, lijada o unida por los extremos, de espesor superior a 6 mm",
    subProduct53: "4408 Hojas para enchapado (incluidas las obtenidas por corte de madera laminada), para contrachapado o para otras maderas laminadas similares y demás maderas, aserradas longitudinalmente, cortadas o desenrolladas, incluso cepilladas, lijadas, empalmadas o unidas por los extremos, de espesor no superior a 6 mm",
    subProduct54: "4409 Madera (incluidas las tiras y frisos para parqué, sin ensamblar) conformada de forma continua (machihembrada, ranurada, rebajada, achaflanada, en V, rebordeada, moldeada, redondeada o similares) por cualquiera de sus bordes, extremos o caras, incluso no cepillado, lijado ni ensamblado en los extremos",
    subProduct55: "4410 Tableros de partículas, tableros de virutas orientadas (OSB) y tableros similares (por ejemplo, waferboards) de madera u otras materias leñosas, incluso aglomerados con resinas u otras sustancias aglutinantes orgánicas.",
    subProduct56: "4411 Tableros de fibras de madera u otras materias leñosas, incluso aglutinados con resinas u otras sustancias orgánicas",
    subProduct57: "4412 Madera contrachapada, tableros enchapados y maderas similares laminadas",
    subProduct58: "4413 Madera densificada, en bloques, placas, tiras o perfiles",
    subProduct59: "4414 Marcos de madera para cuadros, fotografías, espejos u objetos similares",
    subProduct60: "4415 Cajones, cajas, jaulas, tambores y envases similares, de madera; tambores para cables de madera; paletas, paletas caja y demás plataformas de carga, de madera;",
    subProduct61: "collarines para paletas de madera (sin incluir el material de embalaje utilizado exclusivamente como material de embalaje para soportar, proteger o transportar otro producto comercializado)",
    subProduct62: "4416 Barriles, toneles, tinas, tinas y demás manufacturas de tonelería y sus partes, de madera, incluidas las duelas",
    subProduct63: "4417 Herramientas, cuerpos de herramientas, mangos de herramientas, cuerpos y mangos de escobas o cepillos, de madera; hormas y hormas para botas o calzado, de madera",
    subProduct64: "4418 Ebanistería y carpintería de madera para la construcción, incluidos paneles de madera celular, paneles para pisos ensamblados, tejas y tejas",
    subProduct65: "4419 Vajilla y artículos de cocina, de madera.",
    subProduct66: "4420 Marquetería y taracea de madera; cofres y estuches para joyería o cuchillería y artículos similares, de madera; estatuillas y demás objetos de adorno, de madera; artículos de mobiliario de madera no comprendidos en el capítulo 94",
    subProduct67: "4421 Otras manufacturas de madera",
    subProduct68: "Pasta y papel de los capítulos 47 y 48 de la Nomenclatura Combinada, con excepción de los productos a base de bambú y los productos recuperados (desperdicios y desechos)",
    subProduct69: "49 Libros impresos, periódicos, fotografías y demás productos de la industria gráfica, manuscritos, textos mecanografiados y planos, de papel.",
    subProduct70: "9401 Asientos (excepto los de la partida 9402), incluso transformables en cama, y ​​sus partes, de madera",
    subProduct71: "9403 30 , 9403 40 , 9403 50 , 9403 60 y 9403 91 Muebles de madera y sus partes",
    subProduct72: "9406 10 Construcciones prefabricadas de madera",
    totalNoOfDeforestation: "Número Total de Deforestación",
    
    blockchainVerification: "Verificación de Blockchain",
    scanQrBlockchain: "Escanee este código QR para ver el Informe de diligencia debida del EUDR en blockchain.",
    downloadQrCode: "Descargar código QR",
    eudrPublicReport: "Informe público de diligencia debida de Dimitra EUDR",
    scanQrEudr: "Escanee este código QR para ver el Informe de diligencia debida del EUDR en la web pública.",
    viewReportForPublic: "Haga clic aquí para ver el informe para el público",
  
    riskAssessmentNotApproved: "los lugares de producción no están aprobados.",
    viewReportOnBlockChain: "Haga clic aquí para ver el informe en la cadena de bloques",


    declarationMissing: "Declaración Ausente",
    removeRiskFarms: "ELIMINAR FINCAS DE RIESGO",
    disregardRiskDocument: "IGNORAR FINCAS DE RIESGO",
    attachRiskMitigationDocumentForNonCompliantFarms: "ADJUNTAR DOCUMENTO DE MITIGACIÓN DE RIESGO PARA TODAS LAS FINCAS NO CUMPLIDAS",
    uploadMitigationDocumentForNonCompliantFarms: `Subir un documento de mitigación de riesgos para todas las fincas no cumplidas cambiará el estado de las fincas con "Mitigación Requerida" a "Mitigado Manualmente".`,
    disregardFarmWithIssuesTitle:"Ignorar Fincas",
    disregardFarmWithIssuesMessage: "Al seleccionar 'Ignorar', las fincas con estado de evaluación de riesgo 'Mitigación Requerida' se ignorarán y se eliminarán de este informe. Por favor, confirme que desea continuar.",
    removeRiskFarmTitle: "Eliminar Fincas",
    removeRiskFarmMessage: "Al seleccionar 'Eliminar', las fincas con estado de evaluación de riesgo 'Mitigación Requerida' se eliminarán de este informe. Por favor, confirme que desea continuar.",
      
    fileName: "Nombre del archivo",
    dateAndTime: "Fecha y hora",
    downloadProgressStatus: "Estado del progreso de la descarga",
    downloadHistory: "Historial de descargas",
    downloaded: "Descargado",
    inprogress: "En progreso",
    failed: "Fallido",
    showAllDownloads: "Mostrar todas las descargas",
    inProgress: "En progreso",
    downloadCompleted: "Descarga completada",
    downloadFailed: "Descarga fallida",
    errorDeletingItem: "No se pudo eliminar el elemento. Por favor, inténtelo de nuevo más tarde.",
    anErrorOccuredPlsTryAgain: "Algo salió mal. Por favor, inténtelo de nuevo.",
    invalidData: "Los datos proporcionados no son válidos. Por favor, verifique e inténtelo de nuevo.",
    fileIsReady: "El archivo está listo para usar",
    invalidFilePathOrUrl: "La ruta o URL del archivo no es válida.",
    errorDownloadingFile: "Hubo un problema al descargar el archivo. Por favor, inténtelo de nuevo.",
    downloadInitiated: "Descarga iniciada",
    beingDownloaded: "se está descargando. Tiempo estimado",

    multiStepSurveyDetails: "Según el número de preguntas en un paso, todas las preguntas de la encuesta se agruparán y se mostrarán en pasos. Sin embargo, esta configuración solo está disponible antes de agregar preguntas o subtítulos. Una vez que se agregue una pregunta o un subtítulo, la configuración de múltiples pasos se desactivará automáticamente. Por favor, elimine cualquier pregunta o subtítulo para volver a habilitar esta opción.",
    estimatedTime: "Tiempo estimado",
    tryAgain: "Intentar de nuevo",
    processing: "Procesando",
    attachRiskMitigationDocumentForAllNonCompliantFarms: "Adjuntar Documento de Mitigación de Riesgos para Todas las Fincas No Conformes",
    attachOneRiskMitigationDocumentForAllNonCompliantFarms: "ADJUNTAR UN DOCUMENTO DE MITIGACIÓN DE RIESGOS PARA TODAS LAS FINCAS NO CONFORMES",
    fileRequired: "El archivo es obligatorio",
    errorMitigatingFarms: "Error al mitigar las fincas",
    submit: "Enviar",
    ddsReportProcessing: "Sus informes DDS se están procesando. Se le notificará una vez que se publiquen en la blockchain.",
    fileAlreadyExists: "El archivo ya existe",
    "unknown_error": "Excepción desconocida",
    "geo_location_error": "Error de geolocalización",
    "no_processed_images_found": "No se encontraron imágenes procesadas para la geocerca proporcionada.",
    "no_processed_images_found_tt": "Este error ocurre cuando el sistema no puede encontrar imágenes satelitales procesadas para el área de geocerca especificada. Esto puede deberse a varias razones, como que la geocerca se encuentre en una zona remota con cobertura satelital limitada, o a un problema en el proceso de procesamiento de datos satelitales.",
    "invalid_polygon": "Polígono no válido",
    "invalid_polygon_tt": "Este error ocurre cuando el polígono de la geocerca proporcionado no es válido. Puede deberse a problemas como polígonos que se autointersecan, formato incorrecto u otros errores geométricos que impiden que el sistema procese la geocerca correctamente.",
    "region_not_available": "Región no disponible",
    "area_too_large": "Área demasiado grande",
    "area_too_small": "Área demasiado pequeña",
    "invalid_request_data": "Datos de solicitud no válidos",
    "unknown_error_tt": "Cuando ocurre una excepción no controlada; puede deberse a cualquier problema interno del sistema",
    "geo_location_error_tt": "Ocurre cuando no podemos geocodificar inversamente las coordenadas para obtener la dirección",
    "region_not_available_tt": "Cuando las coordenadas de la geocerca se encuentran en una región para la que no disponemos de modelos de deforestación",
    "area_too_large_tt": "Cuando la geocerca tiene un área mayor a la permitida",
    "area_too_small_tt": "Cuando la geocerca tiene un área menor a la que la API de Python puede procesar",
    "invalid_request_data_tt": "Los datos de entrada no son válidos",
    "maxCharacterLimit": "Se permiten un máximo de {max} caracteres",
    estimatedDdsFeeAmount: "Tarifa estimada de revisión del DDS: {currency} {amount}",
    pricePerTonNote: "{currency} {pricePerTon} por tonelada",
    selectUsers: "Seleccionar Usuarios",
    country: "País",
    dueDiligenceReportsTT: "Una recopilación de los informes de diligencia debida emitidos, que proporciona información sobre el estado o la condición actual de cada informe.",
    alreadyInShipment: "Ya está en un Envío",
    disputeAssessment: "Evaluación de Disputas",
    eudrRefNo: "Número de Referencia EUDR",
    downloadXLSXFormat: "Descargar Formato XLS",
    downloadKMLFormat: "Descargar Formato KML",
    downloadSHPFormat: "Descargar Formato SHP",
    downloadXLSorXLSXFormat: "Descargar Formato XLS o XLSX",
    downloadFarmTemplateCSV: "Descargar Plantilla de Gestión de Granjas (CSV)",
    downloadFarmTemplateXLSX: "Descargar Plantilla de Gestión de Granjas (XLSX)",
    importRowsSkipped: "{count} fila(s) omitida(s): sin coordenadas utilizables. El resto del archivo se está importando.",
    approvalConfirmationTitle: "Confirmación",
    approvalConfirmationMessage: "¿Está seguro de que desea aprobar los informes seleccionados?",
    approvalOnceApprovedTitle: "Una vez aprobado",
    approvalVerifiedByPtsi: "Cada informe se marcará como verificado por PTSI.",
    approvalVerifiedByAgent: "Cada informe se marcará como verificado por NACCU.",
    approvalConfirmationMessageShipment: "¿Está seguro de que desea aprobar los envíos seleccionados?",
    approvalVerifiedByShipment: "Este informe se marcará como Aprobado",
    allAssociatedReportsWillBeApprovedShipment: "Todos los informes DDS asociados también serán aprobados",
    approvalVerificationLinksShipment: "Se generarán enlaces de verificación y códigos QR.",
    approvalNoFurtherChangesShipment: "No se permitirán más cambios.",
    approvalPublishedToBlockchainShipment: "El envío y el DDS se publicarán en la Blockchain y en la web pública de Dimitra.",
    allAssociatedReportsWillBeApproved: "Todos los informes asociados serán aprobados",
    approvalVerificationLinks: "Se generarán enlaces de verificación y códigos QR para cada informe.",
    approvalNoFurtherChanges: "No se permitirán más cambios en ningún informe aprobado.",
    approvalPublishedToBlockchain: "El envío y los informes se publicarán en la Blockchain y estarán disponibles en la web pública de Dimitra.",
    temporaryApprovalLabel: "Aprobación Temporal",
    temporaryApprovalDescription: "Todas las fincas no conformes se marcarán como mitigadas manualmente durante este período. Tras su vencimiento, volverán a su estado de cumplimiento original.",
    approvalExpirationPeriod: "Período de Vencimiento de la Aprobación",
    approvalExpirationDays: "Días",
    approvalExpirationWeeks: "Semanas",
    approvalExpirationMonths: "Meses",
    approvalExpirationYears: "Años",
    approvalCancelButton: "CANCELAR",
    approvalApproveButton: "APROBAR",
    approvalSignatureRequired: "Firma del director / revisor",
    approvalSignatureHint: "Dibuje o suba su firma. Aparecerá en la portada de la Prueba Legal del DDS tras la aprobación.",
    approvalSignatureHintOptional: "Opcional si ya subió una firma al verificar el pago. De lo contrario, suba una aquí para la portada de la Prueba Legal.",
    approvalSignatureUpload: "Subir firma (PNG o JPG)",
    approvalSignatureRequiredError: "Por favor, agregue una firma antes de aprobar.",
    approvalSignaturePreview: "Vista Previa de la Firma",
    ptsiAuthorizedSignatoryTitle: "Firmante Autorizado de PTSI",
    ptsiVerifyOnBehalfHint: "Al aprobar este pago, usted confirma la verificación en nombre del firmante autorizado indicado a continuación. La portada de la Prueba Legal mostrará los datos fijos del firmante.",
    ptsiApproveOnBehalfHint: "Al aprobar este informe, usted confirma en nombre del firmante autorizado indicado a continuación. La portada de la Prueba Legal mostrará los datos fijos del firmante.",
    signatoryName: "Nombre",
    signatoryPosition: "Cargo",
    signatoryCompany: "Empresa",
    digitalSignatureLater: "Se agregará más adelante",
    changeSignature: "Cambiar firma",
    ptsiReviewerSignatureHint: "Agregue su firma arriba en nombre del firmante autorizado. Aparecerá en la portada de la Prueba Legal del DDS tras la aprobación.",
    verifyingAsReviewer: "Verificando como (revisor con sesión iniciada)",
    reviewerName: "Nombre del revisor",
    reviewerEmail: "Correo electrónico del revisor",
    approveShipmentsConfirmation: "¿Está seguro de que desea aprobar los envíos seleccionados?",
    onceApproved: "Una vez aprobado:",
    shipmentMarkedVerified: "Cada envío se marcará como verificado por PTSI.",
    verificationLinksGenerated: "Se generarán enlaces de verificación y códigos QR para cada envío.",
    noFurtherChanges: "No se permitirán más cambios en ningún envío aprobado.",
    publishedToBlockchain: "Los envíos se publicarán en la Blockchain y estarán disponibles en la web pública de Dimitra.",
    assignShipmentDescription: "Seleccione un usuario para asignar los envíos seleccionados. Una vez asignados, se notificará al usuario y se le otorgará acceso para gestionar estos envíos. Puede reasignarlos más adelante si es necesario.",
    selectUser: "Seleccionar Usuario",
    selectUserTooltip: "Elija un usuario al que asignar los informes seleccionados",
    selectUserPlaceholder: "Seleccione un usuario",
    search: "Buscar",
    assignButton: "ASIGNAR",
    pleaseSelectUser: "Por favor, seleccione un usuario",
    rejectShipmentsConfirmation: "¿Está seguro de que desea rechazar los envíos seleccionados?",
    shipmentDataSaved: "Los datos de estos envíos se guardarán tras el rechazo por si desea revisarlos de nuevo más adelante.",
    assignReport: "Asignar Informe",
    assignShipment: "Asignar Envío",
    assignReportConfirmation: "¿Está seguro de que desea asignar el informe?",
    assignShipmentConfirmation: "¿Está seguro de que desea asignar el envío?",
    rejectionWarningTitle: "Advertencia",
    rejectionConfirmationMessage: "¿Está seguro de que desea rechazar los informes seleccionados?",
    rejectionReasonLabel: "Motivo del rechazo",
    rejectionReasonPlaceholder: "Comentarios",
    rejectionReasonRequired: "Por favor, indique un motivo para el rechazo",
    rejectionDataSaved: "Los datos de estos informes se guardarán tras el rechazo por si desea revisarlos de nuevo más adelante.",
    rejectionCancelButton: "CANCELAR",
    rejectionConfirmButton: "CONFIRMAR",
    rejectionNote: "Tenga en Cuenta",
    waitingForPaymentBannerMessage: "Este informe DDS tiene un pago pendiente. Comparta su informe con un exportador y realice el pago pendiente para continuar con el proceso de aprobación.",
    waitingForPaymentSubmittedTo: "Enviado a {exporters}.",
    paymentResponsibilityTitle: "Responsabilidad del Pago",
    paymentResponsibilityDescription: "Este informe DDS se ha compartido con usted como exportador. ¿Acepta la responsabilidad del pago de su tarifa de revisión?",
    paymentResponsibilityWireTransferNote: "El pago de este DDS debe realizarse mediante transferencia bancaria.",
    ddsReferenceNo: "N.º de Referencia del DDS",
    quantityTons: "Cantidad / Toneladas",
    acceptPaymentResponsibility: "Aceptar",
    declinePaymentResponsibility: "Rechazar",
    paymentResponsibilityAccepted: "Ha aceptado la responsabilidad del pago de este informe.",
    paymentResponsibilityDeclined: "Ha rechazado la responsabilidad del pago de este informe.",
    acceptingPaymentResponsibility: "Aceptando la responsabilidad del pago...",
    decliningPaymentResponsibility: "Rechazando la responsabilidad del pago...",
    releasePaymentResponsibility: "Renunciar a la Responsabilidad del Pago",
    exitAsPayer: "Salir como Pagador",
    releasePaymentResponsibilityConfirm: "¿Renunciar a la responsabilidad del pago de este informe? Otros exportadores con los que se haya compartido podrán aceptarla y continuar con el pago.",
    paymentResponsibilityReleased: "Responsabilidad del pago liberada. Ahora otros exportadores pueden aceptarla.",
    exporterLockedOutByPayment: "Este informe DDS ya no está disponible para usted porque otro exportador aceptó la responsabilidad del pago.",
    paymentAssignedToAnotherExporter: "Pago No Disponible",
    paymentUnavailableTooltip: "La responsabilidad del pago ya ha sido aceptada por otro exportador.",
    reportPayment: "Continuar con el Pago",
    paymentAmountDue: "Importe a Pagar",
    bankTransferDetails: "Datos de la Transferencia Bancaria",
    uploadReceipt: "Subir Comprobante",
    uploadReceiptPlaceholder: "Seleccione un archivo de comprobante de transferencia bancaria",
    uploadReceiptHint: "Suba una imagen clara o un PDF de su comprobante de transferencia bancaria.",
    uploadReceiptRequired: "Por favor, suba un comprobante de pago",
    paymentTransactionNote: "Nota de la Transacción (Opcional)",
    paymentTransactionNotePlaceholder: "Agregue la referencia bancaria, la fecha de la transferencia u otras notas del pago",
    reportPaymentSubtitle: "Envíe su comprobante de transferencia bancaria para el pago de la tarifa de revisión del DDS",
    submitPayment: "Enviar Pago",
    submittingPayment: "Enviando pago...",
    uploadingReceipt: "Subiendo comprobante...",
    paymentReportedSuccessfully: "Pago informado correctamente. PTSI lo verificará en breve.",
    paymentReportedByExporterNotice: "Este DDS se ha compartido con un exportador, por lo que el exportador es responsable de informar el pago.",
    verifyPayment: "Verificar Pago",
    verifyPaymentReceipt: "Verificar Comprobante de Pago",
    verifyPaymentSubtitle: "Revise los detalles de la factura y el comprobante de pago subido antes de aprobar o rechazar.",
    receiptPreview: "Vista Previa del Comprobante",
    loadingReceipt: "Cargando comprobante…",
    receiptPreviewUnavailable: "No se pudo cargar la vista previa del comprobante. Inténtelo de nuevo o ábralo en una pestaña nueva.",
    receiptPreviewUnsupported: "Este tipo de archivo no se puede previsualizar aquí. Ábralo en una pestaña nueva para revisarlo.",
    receiptPreviewRetry: "Reintentar",
    paymentVerified: "Pago Verificado",
    paymentRejected: "Pago Rechazado",
    paymentPendingVerification: "Pendiente de Verificación",
    paymentPayer: "Pagador",
    paymentReceipt: "Comprobante",
    paymentRejectionReasonLabel: "Motivo del rechazo",
    paymentRejectionReasonRequired: "Por favor, indique un motivo para rechazar este pago",
    approvePayment: "Aprobar",
    rejectPayment: "Rechazar",
    approvingPayment: "Aprobando pago...",
    rejectingPayment: "Rechazando pago...",
    generateInvoice: "Generar Factura",
    invoiceGeneratedSuccessfully: "Factura generada correctamente.",
    viewInvoice: "Ver Factura",
    viewInvoiceAndReceipt: "Ver Factura y Comprobante",
    submittedPaymentProof: "Comprobante de Pago Enviado",
    receiptSubmittedBy: "Enviado por",
    receiptSubmittedAt: "Enviado el",
    receiptSubmittedByYou: "Usted",
    receiptSubmittedByAnotherExporter: "Otro exportador",
    receiptNotSubmittedYet: "Todavía no se ha enviado ningún comprobante de pago.",
    openSubmittedReceipt: "Abrir Comprobante Enviado",
    paymentProofNote: "Nota de la Transacción",
    paymentProofHintYou: "Este es el comprobante de pago que usted envió para esta factura.",
    paymentProofHintOther: "El comprobante de pago fue enviado por otro exportador que aceptó la responsabilidad del pago.",
    downloadInvoice: "Descargar Factura",
    ddsReviewFeeInvoice: "Factura de la Tarifa de Revisión del DDS",
    invoiceHeader: "Encabezado de la Factura",
    invoiceNumber: "Número de Factura",
    invoiceDate: "Fecha de la Factura",
    paymentStatus: "Estado del Pago",
    invoiceGeneratedStatus: "Factura Generada",
    payerInformation: "Información del Pagador",
    exporterName: "Nombre del Exportador",
    exporterCompanyId: "ID del Exportador / ID de la Empresa",
    exporterContact: "Contacto / Correo Electrónico del Exportador",
    ddsProductInformation: "Información del DDS / Producto",
    quantityNetMass: "Cantidad / Masa Neta",
    unit: "Unidad",
    unitTon: "Tonelada",
    pricingInformation: "Información de Precios",
    calculatedAmount: "Importe Calculado",
    paymentInformation: "Información del Pago",
    totalAmountPayable: "Importe Total a Pagar",
    bankAccountInstructions: "Cuenta Bancaria / Instrucciones de Pago",
    bankTransferPaymentInstructions: "Por favor, transfiera el importe total a pagar a la cuenta bancaria indicada a continuación y suba su comprobante de pago.",
    paymentDueStatus: "Estado del Pago Pendiente",
    paymentDue: "Pago Pendiente",
    paymentPaid: "Pagado",
    bankDetails: "Datos Bancarios",
    bankName: "Nombre del Banco",
    accountName: "Nombre de la Cuenta",
    accountNumber: "Número de Cuenta",
    invoiceFooterNote: "Esta factura se emite para el pago de la tarifa de revisión del DDS. Por favor, conserve una copia para sus registros.",
    ddsPaymentPricingTitle: "Precios de Pago del DDS",
    ddsPaymentPricingSubtitle: "Establezca el precio por tonelada que se cobra por revisar un DDS, por producto y país. El precio se determina según el país registrado de la organización que informa. Los informes de productos sin un precio configurado omiten el paso de pago.",
    pricePerTon: "Precio por Tonelada",
    ddsPricePerTon: "Precio del DDS por Tonelada",
    currency: "Moneda",
    pricingCountry: "País",
    pricingProduct: "Producto",
    pricingActions: "Acciones",
    addPricing: "Agregar Precio",
    updatePricing: "Actualizar Precio",
    pricingSavedSuccessfully: "Precio guardado correctamente.",
    deletePricing: "Eliminar Precio",
    pricingDeleteConfirm: "¿Está seguro de que desea eliminar esta configuración de precios?",
    pricingDeletedSuccessfully: "Configuración de precios eliminada correctamente.",
    noPricingSettingsConfigured: "Aún no hay configuraciones de precios definidas.",
    organizationCountryLabel: "País de la Organización",
    organizationCountrySubtitle: "El país registrado de su organización. Se utiliza para determinar los precios de pago del DDS configurados por país.",
    organizationCountrySavedSuccessfully: "País de la organización guardado correctamente.",
    enterPricePerTon: "Ingrese el Precio por Tonelada",
    selectCurrency: "Seleccionar Moneda",
    reviewProductionPlaceRiskAdvisory: "Por favor, revise la siguiente evaluación de riesgo de deforestación del lugar de producción y mitíguelo en consecuencia antes de continuar.",
    riskAdvisoryMitigationRecommended: "Aviso de Riesgo — Mitigación Recomendada",
    riskAdvisoryMitigationRecommendedBody: "{count} finca(s) han sido señaladas con algún riesgo que puede causar retrasos durante la aprobación. La documentación de mitigación no es obligatoria, pero se recomienda encarecidamente antes de enviar.",
    riskAdvisoryMitigationRequired: "Aviso de Riesgo — Mitigación Obligatoria",
    riskAdvisoryMitigationRequiredBody: "{count} finca(s) presentan hallazgos de alto riesgo que deben resolverse antes de poder enviar este DDS. No puede continuar hasta que se haya subido la documentación de mitigación para todas las fincas de alto riesgo.",
    uploadMitigationDocumentationRecommended: "Subir Documentación de Mitigación (Recomendado)",
    uploadMitigationDocumentation: "Subir Documentación de Mitigación",
    requestToUploadMitigation: "Solicitar Subida",
    requestAdditionalInformationBatchHint: "Al enviar esta solicitud se notificará al cooperador una sola vez con los {count} lugar(es) de producción en cola que se indican a continuación.",
    requestAdditionalInformationBatchEmptyHint: "Puede poner fincas individuales en cola mediante Solicitar Subida o Solicitar Revisión, y después enviar desde aquí una única notificación acumulada.",
    supplierNotFoundForRequest: "No se pudo identificar al proveedor de este informe. Por favor, actualice la página e inténtelo de nuevo.",
    farmsPendingRevisionBatch: "Lugares de Producción en Cola para Actualización",
    farmsPendingRevisionBatchHint: "Estas fincas se pusieron en cola a partir de acciones de revisión individuales. Se enviará un único correo electrónico y una única notificación consolidados cuando envíe la solicitud.",
    revisionRequired: "Revisión Requerida",
    uploadRequired: "Subida Requerida",
    attachReferenceDocuments: "Adjuntar Documentos de Referencia",
    attachReferenceDocumentsHint: "Opcional. Suba documentos de apoyo o plantillas para que el proveedor los consulte al enviar las pruebas de mitigación.",
    selectDocumentsToAttach: "Seleccionar documentos para adjuntar",
    attachedDocuments: "Documentos Adjuntos",
    approveMitigationWithoutDocumentsNote: "Una o más fincas seleccionadas no tienen documentos de mitigación subidos. Aun así puede aprobarlas con estado de mitigación temporal.",
    approveMitigationWithoutDocumentsPermanentNote: "Una o más fincas seleccionadas no tienen documentos de mitigación subidos. Se marcarán permanentemente como Mitigadas Manualmente.",
    approveMitigationEvidenceTitle: "Aprobar Pruebas de Mitigación",
    approveMitigationEvidenceButton: "Aprobar Pruebas",
    approveMitigationEvidenceIntroSingle: "Aprobar las pruebas de {name}.",
    approveMitigationEvidenceIntroBulk: "Aprobar las pruebas de {count} fincas.",
    approveMitigationEvidencePermanentSummary: "La(s) finca(s) se marcarán permanentemente como Mitigadas Manualmente.",
    approveMitigationEvidenceTemporarySummary: "La(s) finca(s) se marcarán como Mitigadas Manualmente durante el período seleccionado y después volverán a su estado de riesgo original.",
    approveMitigationEvidenceRevertNote: "Transcurrido este período, cada finca vuelve a su estado de cumplimiento anterior (por ejemplo, Riesgo Medio).",
    approveMitigationNoDocumentsWarningTitle: "Faltan documentos de mitigación",
    proceedWithoutMitigation: "Continuar Sin Mitigación",
    cancelAndCreateNewDds: "Cancelar y Crear un Nuevo DDS",
    legendMitigationRecommended: "Mitigación Recomendada",
    legendMitigationRequired: "Mitigación Obligatoria",
    legendMitigationUploaded: "Mitigación Subida",
    localDbAndEudrMitigationTitle: "Cumplimiento de BD Local y Mitigación de Deforestación EUDR",
    localDbAndEudrMitigationSubtitle: "Revise las pruebas del proveedor para las fincas de riesgo medio y alto señaladas en Cumplimiento de BD Local y Estado de Deforestación EUDR",
    eudrAssessmentCannotProceedTitle: "No se Puede Continuar",
    eudrAssessmentRiskDetectedInPlaces: "Riesgo detectado en {count} lugar de producción | Riesgo detectado en {count} lugares de producción",
    eudrAssessmentCannotProceedSubtext: "Estos lugares de producción deben alcanzar el estado Cero/Insignificante o Mitigado Manualmente antes de que pueda continuar al siguiente paso.",
    eudrAssessmentCannotProceedHelperTitle: "Cómo resolver las fincas con riesgo detectado",
    eudrAssessmentCannotProceedStep1: "Localice el lugar de producción afectado en la tabla y abra el menú de acciones (icono del portapapeles) a la derecha.",
    eudrAssessmentCannotProceedStep2: "Seleccione Mitigación Manual de Riesgo y suba los documentos de apoyo para su revisión de riesgos.",
    eudrAssessmentCannotProceedStep3: "Una vez aprobada la mitigación, el estado EUDR cambiará a Mitigado Manualmente y podrá continuar.",
    eudrAssessmentCannotProceedStep4: "Si no está de acuerdo con la evaluación de deforestación, presente una solicitud de Disputa desde el mismo menú de acciones.",
    eudrAssessmentCannotProceedTimelineNote: "Tenga en cuenta: las revisiones de Mitigación Manual de Riesgo suelen completarse en unos pocos días hábiles. La resolución de disputas y la reevaluación pueden tardar de varios días a una semana o más, según el volumen de revisiones. Se le notificará una vez que se tome una decisión y podrá continuar cuando se actualice el estado.",
    eudrAssessmentCannotProceedGoBack: "Volver",
    productionPlacesCount: "lugar(es) de producción",
    usageLimitsTT: "Se refiere a las restricciones o cuotas predefinidas sobre el número de veces que se puede acceder, generar o utilizar estos informes y evaluaciones en un período determinado. Estos límites se establecen para gestionar la asignación de recursos, garantizar un uso justo y mantener el rendimiento del sistema.",
    totalNoOfLocalDbHighRiskFarms: "Número Total de Riesgo Alto (Cumplimiento de BD Local)",
    totalNoOfLocalDbHighRiskFarmsTT: "Conteo de lugares de producción con riesgo alto de cumplimiento de la base de datos local.",
    totalNoOfLocalDbMediumRiskFarms: "Número Total de Riesgo Medio (Cumplimiento de BD Local)",
    totalNoOfLocalDbMediumRiskFarmsTT: "Conteo de lugares de producción con riesgo medio de cumplimiento de la base de datos local.",
    productionPlaces: "Lugares de Producción",
    productionPlacesTT: "Muestra una lista de los lugares de producción existentes junto con detalles como el nombre del productor, país, área, tipo y estado de la evaluación.",
    nonComplianceReasons: "Motivos de incumplimiento",
    nonComplianceDeforestationStatus: "Lugares de producción con un estado de deforestación distinto de cero",
    nonComplianceRiskAssessmentStatus: "Lugares de producción con un estado de evaluación de riesgos distinto de cero",
    nonComplianceLargerThanFourHectares: "Lugares de producción de más de 4 hectáreas",
    nonComplianceFarmInOcean: "Lugares de producción situados en el océano",
    nonComplianceFarmInDifferentLocation: "Lugares de producción situados en una ubicación diferente",
    nonComplianceGeofenceNotChecked: "Lugares de producción cuya geocerca aún no se ha verificado",
    sendToOperator: "Enviar al Operador",
    expiryDate: "Fecha de Vencimiento",
    selectDate: "Seleccionar Fecha",
    invalidCSVFile: "Archivo CSV no válido. Por favor, revise el archivo e inténtelo de nuevo.",
    missingColumnsExact: "Faltan columnas obligatorias: {columns}",
    validCSVFile: "El archivo CSV es válido.",
    validExcelFile: "El archivo Excel es válido.",
    invalidExcelFile: "Archivo Excel no válido. Por favor, revise el archivo e inténtelo de nuevo.",
    finishStepsTooltip: "Complete los pasos 1 a 3 haciendo clic en 'Siguiente' en cada uno para desbloquear esta pestaña.",
    viewDownloadHistory: "Ver Historial de Descargas",
    eudrDocumentCodes: "Código(s) de Documento EUDR",
    referenceNumberForC717: "Número de Referencia para C717",
    exporterData: "Datos del Exportador",
    reportSharedSuccessfully: "Informe compartido correctamente",
    shareReportWithExporter: "Compartir Informe con el Exportador",
    shareReadOnlyReport: "Compartir Informe de Solo Lectura",
    shareReportToOperator: "Compartir Informe con el Operador",
    verificationNumber: "Número de Verificación",
    dueDiligenceReport: "Informe de Diligencia Debida",
    productDetails: "Detalles del Producto",
    statusHistory: "Historial de Estados",
    viewStatusHistory: "Ver Historial de Estados",
    dateTime: "Fecha y Hora",
    expiresOn: "Vence el",
    failedToLoadHistory: "No se pudo cargar el historial de estados",
    productionPlaceIdNotFound: "No se encontró el ID del lugar de producción",
    noHistoryFound: "No se encontró historial",
    accessAndVerify: "Acceder y Verificar Informes de Diligencia Debida",
    searchReportOrShipmentTitle: "Ingrese un ID de Informe o un ID de Envío proporcionado por el exportador para revisar los detalles del informe.",
    searchReportOrShipmentPlaceholder: "Buscar por ID de Informe o ID de Envío",
    reportStatus: "Estado del Informe",
    assignedTo: "Asignado a",
    assignReports: "Asignar Informes",
    approveReports: "Aprobar Informes",
    rejectReports: "Rechazar Informes",
    reportsSelected: "Informes Seleccionados",
    daysOld: "Días de Antigüedad",
    pleaseSelectUserToAssign: "Seleccione un usuario para asignar los informes DDS seleccionados. Una vez asignados, se notificará al usuario y se le otorgará acceso para gestionar estos informes. Puede reasignarlos más adelante si es necesario.",
    chooseUserToAssign: "Elija un usuario al que asignar los informes seleccionados",
    assign: "Asignar",
    today: "Hoy",
    week: "Semana",
    month: "Mes",
    year: "Año",
    all: "Todos",
    selectDateRange: "Seleccionar Rango de Fechas",
    selectStartDate: "Seleccionar Fecha de Inicio",
    selectEndDate: "Seleccionar Fecha de Fin",
    apply: "Aplicar",
    activeCooperatives: "Cooperativas Activas",
    activeUnionAgents: "Uniones Activas",
    numberActiveCooperatives: "Número de cooperativas activas en el sistema",
    numberActiveUnionAgents: "Número de uniones/agentes activos en el sistema",
    activeExporters: "Exportadores Activos",
    activeAgent: "Agentes Activos",
    totalNumberRegisteredFarms: "Número total de fincas registradas en el sistema",
    registeredFarms: "Fincas Registradas",
    ddsCompliant: "DDS Conformes",
    numberDdsReportsCompliant: "Número de informes DDS que son conformes",
    ddsApproved: "DDS Aprobados",
    numberDdsReportsApproved: "Número de informes DDS que han sido aprobados",
    ddsAssignedToMe: "DDS Asignados a Mí",
    numberDdsReportsAssignedToMe: "Número de informes DDS asignados a mí",
    ddsOverdue: "DDS Vencidos",
    numberDdsReportsOverdue: "Número de informes DDS vencidos",
    ddsNonCompliant: "DDS No Conformes",
    numberDdsReportsNonCompliant: "Número de informes DDS que no son conformes",
    ddsRejected: "DDS Rechazados",
    numberDdsReportsRejected: "Número de informes DDS que han sido rechazados",
    selectRegion: "Seleccionar Región",
    resetFilters: "Restablecer Filtros",
    start: "Inicio",
    end: "Fin",
    date: "Fecha",
    averageProcessingTimeDays: "Tiempo Medio de Procesamiento (Días)",
    assignedEmployees: "Empleados Asignados",
    reportsProcessed: "Informes Procesados",
    averageTime: "Tiempo Medio",
    averageTimeToProcessDdsReport: "Tiempo Medio para Procesar un Informe DDS",
    filterBy: "Filtrar Por",
    loadingChartData: "Cargando datos del gráfico...",
    noDataAvailable: "No hay datos disponibles",
    ddsReports: "Informes DDS",
    comprehensiveViewOfAllDueDiligenceReportsAndTheirStatus: "Vista completa de todos los informes de diligencia debida y su estado",
    ddsReportSubmissions: "Envíos de Informes DDS",
    monthlyBreakdownOfDdsReportSubmissionsByStatus: "Desglose mensual de los envíos de informes DDS por estado",
    ddsReportsByProducts: "Informes DDS por Producto",
    ddsReportsByStatus: "Informes DDS por Estado",
    allProducts: "Todos los Productos",
    statusLabels: {
      pending_approval: "Pendiente de Aprobación",
      overdue: "Vencido",
      approved: "Aprobado",
      rejected: "Rechazado",
      processing: "Procesando",
      compliant: "Conforme",
      non_compliant: "No Conforme",
      under_review: "En Revisión",
      temporary_approved: "Aprobado Temporalmente",
      shipment_in_process: "Envío en Proceso",
    },
    numberActiveExporters: "Número de exportadores activos en el sistema",
    numberActiveAgents: "Número de agentes activos en el sistema",
    ddsReportsApproved: "Informes DDS Aprobados",
    pendingDdsReports: "Informes DDS Pendientes",
    overdueDdsReports: "Informes DDS Vencidos",
    rejectedDdsReports: "Informes DDS Rechazados",
    applyFilter: "Aplicar Filtro",
    makeSelection: "Realizar Selección",
    assignToMe: "ASIGNARME",
    assignToMeConfirmation: "¿Está seguro de que desea asignarse este informe DDS? Una vez asignado, usted será responsable de revisarlo y completarlo.",
    assignToMeConfirmButton: "SÍ, ASIGNÁRMELO",
    onlyReportsAssignedToYouCanBeSelected: "Solo se pueden seleccionar los informes asignados a usted",
    thisReportIsAssignedTo: "Este informe está asignado a {assignedUserName}. Solo se pueden seleccionar los informes asignados a usted.",
    thisReportIsNotAssignedToAnyoneOnlyReportsAssignedToYouCanBeSelected: "Este informe no está asignado a nadie. Solo se pueden seleccionar los informes asignados a usted.",
    noReportSelectedForAssignment: "No se ha seleccionado ningún informe para asignar",
    userInformationNotAvailable: "La información del usuario no está disponible",
    checkingComplianceStatus: "Verificando el estado de cumplimiento...",
    nonCompliantFarmsDetected: "Fincas con Riesgo Detectado",
    approvalCompliantAndManuallyMitigated: "El estado del informe cambiará a Conforme y las fincas con problemas o estado no conforme pasarán a Mitigadas Manualmente.",
    approvalCompliantAndRiskDetected: "El estado del informe cambiará a Conforme y las fincas con problemas o con riesgo detectado pasarán a Mitigadas Manualmente.",
    additionalInformationRequested: "Información Adicional Solicitada",
    supplierUpdates: "Actualizaciones del Proveedor",
    noDescriptionProvided: "No se proporcionó descripción",
    supplierHasRespondedAndMadeUpdates: "El proveedor ha respondido a su solicitud de información adicional y ha realizado las siguientes actualizaciones en este informe DDS:",
    removedFarms: "Fincas Eliminadas",
    updatedFarms: "Fincas Actualizadas",
    addedNewFarms: "Fincas Nuevas Agregadas",
    noFarmChanges: "Sin cambios en las fincas",
    farmsAdded: "Fincas Agregadas",
    farmsRemoved: "Fincas Eliminadas",
    farmsUpdated: "Fincas Actualizadas",
    addressOfProduction: "Dirección de Producción",
    locationStatus: "Estado de la Ubicación",
    viewFarm: "Ver Finca",
    locationStatusTT: "Estado de verificación de las coordenadas y los límites de la ubicación del lugar de producción.",
    locationVerified: "Ubicación Verificada",
    locationError: "Error de Ubicación",
    geofenceError: "Error de Geocerca",
    farmOverlapped: "Finca Superpuesta",
    countryMismatchError: "El país de producción es diferente de la ubicación de la geocerca de la finca.",
    circularFarmAreaTooLarge: "La finca circular tiene un área superior a 4,0 ha.",
    farmOverlapMessage: "La geocerca de la finca se superpone con otra finca {farmName}",
    farmOverlapGeneric: "La geocerca de la finca se superpone con otra finca",
    dateOfIssue: "Fecha de Emisión",
    dateOfExpiry: "Fecha de Vencimiento",
    dateOfSubmission: "Fecha de Envío",
    assessments: "Evaluaciones",
    riskAssessmentTT: "La evaluación de riesgos valora las amenazas potenciales y los requisitos de cumplimiento del lugar de producción.",
    noRiskAssessment: "No Hay Evaluación de Riesgos Disponible",
    indigenousAndProtectedAreas: "Áreas Indígenas y Protegidas",
    indigenousAndProtectedAreasTT: "Verificación de si el lugar de producción se cruza con territorios indígenas o áreas protegidas.",
    interceptsProtectedArea: "Intersecta Área Protegida",
    interceptsProtectedAreaTT: "Indica si el lugar de producción se superpone con alguna área protegida.",
    interceptsIndigenousArea: "Intersecta Área Indígena",
    interceptsIndigenousAreaTT: "Indica si el lugar de producción se superpone con algún territorio indígena.",
    mitigationDocuments: "Documentos de Mitigación",
    mitigationDocumentsTT: "Documentos subidos para demostrar las medidas de mitigación de riesgos adoptadas para el lugar de producción.",
    noMitigationDocuments: "No Hay Documentos de Mitigación Disponibles",
    mitigationComments: "Comentarios",
    noMitigationComments: "No hay comentarios disponibles",
    showDetails: "Mostrar Detalles",
    hideDetails: "Ocultar Detalles",
    ddsReportLog: "Registro del Informe DDS",
    ddsReportLogTT: "El Registro del Informe DDS realiza el seguimiento de diversas actividades relacionadas con el propio informe DDS",
    ddsApprovalLog: "Registro de Aprobación del DDS",
    ddsApprovalLogTT: "El Registro de Aprobación del DDS registra las actividades relacionadas con el flujo de aprobación del informe DDS",
    productAndQuantity: "Producto y Cantidad",
    buyingStationProcessor: "Estación de Compra / Procesador",
    downloadPdfWithAccessKey: "Descargar PDF con Clave de Acceso",
    downloadPdfWithAccessKeyConfirmQuestion: "¿Está seguro de que desea descargar este informe DDS con un código de acceso?",
    downloadPdfWithAccessKeyExplanation: "El código de acceso permite al destinatario importar estos datos del DDS a su propia cuenta. Dispondrá de toda la información adjunta al DDS. Si no desea otorgar acceso completo al DDS, descargue el PDF estándar sin código de acceso.",
    downloadPdfWithAccessKeyError: "La descarga falló. Es posible que el servidor aún no admita el PDF con clave de acceso.",
    ddsReportExchange: "Intercambio de Informes DDS",
    importDdsReport: "Importar Informe DDS",
    exchangeRequests: "Solicitudes de Intercambio",
    importDdsReportDescription: "Si está comerciando con una empresa que también utiliza la Plataforma de Diligencia Debida de Dimitra, puede importar directamente su informe de diligencia debida. Puede introducir el Número de Referencia Interna para enviar una solicitud de aprobación, o introducir un Código de Acceso proporcionado por la empresa para obtener acceso inmediato. Una vez aprobado, el informe estará disponible en la sección 'Informe de Diligencia Debida'.",
    selectMethodOfImport: "Seleccionar Método de Importación",
    requestInternalRefNumber: "Solicitar Número de Referencia Interna",
    iHaveAccessCode: "Tengo un Código de Acceso",
    accessCode: "Código de Acceso",
    accessCodeTooltip: "Introduzca el código de acceso proporcionado por la empresa para importar su informe DDS.",
    enterHere: "Ingrese aquí",
    internalRefRequestTooltip: "Introduzca el número de referencia interna para enviar una solicitud a la empresa.",
    accessTheReport: "ACCEDER AL INFORME",
    exchangeRequestsTabDescription: "Vea y gestione sus solicitudes de intercambio de informes DDS.",
    exchangeHistory: "Historial de Intercambios",
    exchangeHistoryDescription: "A continuación se muestra el historial de los informes DDS que ha importado de otras empresas a través de la Plataforma de Diligencia Debida de Dimitra. Puede seguir el estado de las solicitudes pendientes, ver los informes compartidos con usted mediante Número de Referencia o acceder a los informes desbloqueados con un Código de Acceso.",
    incomingReportRequests: "Solicitudes de Informes Entrantes",
    incomingReportRequestsTooltip: "Solicitudes de compartición de informes que le han enviado otros usuarios.",
    incomingReportRequestsDescription: "Aquí puede ver todas las solicitudes de compartición de informes procedentes de otros usuarios. Revise las solicitudes y apruébelas o recházelas. Las solicitudes aprobadas otorgan acceso al informe completo.",
    ddsInternalReferenceNo: "N.º de Referencia Interna del DDS",
    productFilterTooltip: "Filtrar por nombre o código de producto.",
    requestApproved: "Solicitud aprobada.",
    requestRejected: "Solicitud rechazada.",
    approve: "Aprobar",
    reject: "Rechazar",
    requestId: "ID de Solicitud",
    enterprise: "Empresa",
    importMethod: "Método de Importación",
    requestStatus: "Estado de la Solicitud",
    requestIdDate: "ID de Solicitud / Fecha",
    requestingEnterpriseNameId: "Nombre / ID de la Empresa Solicitante",
    productQuantity: "Producto/Cantidad",
    dueDiligenceStatus: "Estado de la Diligencia Debida",
    compliant: "Conforme",
    accessReportSuccess: "Informe vinculado correctamente. Puede verlo en Informes de Diligencia Debida.",
    accessReportError: "Código de acceso no válido o caducado. Por favor, verifíquelo e inténtelo de nuevo.",
    exchangeHistoryLoadError: "No se pudo cargar el historial de intercambios.",
    importingTitle: "Importando",
    importingMessage: "Estamos obteniendo los datos del informe y sincronizando los detalles con la blockchain. Esto puede tardar unos momentos. Puede esperar aquí o consultar el estado en su Historial de Intercambios.",
    cancelImport: "CANCELAR IMPORTACIÓN",
    runInBackground: "EJECUTAR EN SEGUNDO PLANO",
    checkExchangeHistory: "La importación se está ejecutando en segundo plano. Consulte el Historial de Intercambios para ver el estado.",
    requestSent: "Solicitud enviada correctamente.",
    copied: "Copiado",
    shareReport: "Compartir Informe",
    shareReportWithInternalUser: "Compartir Informe con un Usuario Interno de Dimitra",
    shareReportWithInternalUserTooltip: "Comparta este informe con un usuario registrado en la plataforma Dimitra.",
    shareReportWithExternalUser: "Compartir Informe con un Usuario Externo por Correo Electrónico",
    shareReportWithExternalUserTooltip: "Comparta este informe con un usuario externo por correo electrónico.",
    enterUserEmail: "Ingrese el Correo Electrónico del Usuario",
    userSearchError: "No se pudo buscar al usuario. Aun así puede continuar con la compartición.",
    pleaseEnterEmail: "Por favor, ingrese una dirección de correo electrónico.",
    shareReportError: "No se pudo compartir el informe. Por favor, inténtelo de nuevo.",
    accessLevel: "Nivel de Acceso",
    shareFullDataReport: "Compartir Informe de Datos Completo",
    shareFullDataReportDescription: "Genera un código de acceso que permitirá al destinatario importar los datos del DDS a su propia cuenta.",

    iyb: {
      riskLabelZero: "Cero",
      notAvailable: "N/D",
      importSpreadsheetTitle: "Importar hoja de cálculo de puntuación IYB",
      uploadFile: "Subir archivo",
      previewData: "Vista previa de datos",
      confirmImport: "Confirmar importación",
      uploadPtsiSpreadsheet: "Subir hoja de cálculo de PTSI",
      uploadDescription: "Sube la hoja de cálculo IYBv2 BOGOR proporcionada por PTSI. Este archivo contiene el estado de riesgo EUDR y 13 puntuaciones de indicadores para las 514 regencias de Indonesia.",
      acceptedFormats: "Formatos aceptados",
      or: "o",
      clickOrDragFileHere: "Haz clic o arrastra y suelta aquí el archivo IYBv2 BOGOR",
      acceptsCsvOrXlsx: "Acepta .csv o .xlsx",
      dataYear: "Año de datos",
      selectYearHint: "Selecciona el año que representa estos datos IYB. Los datos de años anteriores se conservarán.",
      previewImportData: "Vista previa de datos de importación",
      showingRows: "Mostrando filas {from} - {to}",
      totalRegenciesFound: "Total de regencias encontradas",
      records: "registros",
      firePreventionTooltip: "Incendios forestales y de tierras (IYBv2 BOGOR ind2). Para aceite de palma: Rojo (≤40) bloquea el envío DDS.",
      lowRiskFastTrack: "Riesgo bajo → VERDE (vía rápida)",
      mediumRiskMitigation: "Riesgo medio → AMARILLO (mitigación)",
      highRiskAppealPath: "Riesgo alto → ROJO (ruta de apelación)",
      proceedToConfirm: "Continuar para confirmar",
      confirmImportDescription: "La importación agregará o actualizará puntuaciones IYB para {total} regencias del año {year}. Las puntuaciones de otros años no se verán afectadas.",
      totalRegencies: "Total de regencias",
      importNow: "Importar ahora",
      regencyId: "ID de regencia",
      regencyName: "Nombre de regencia",
      iybScore: "Puntuación IYB",
      firePrevention: "Prevención de incendios",
      eudrRiskStatus: "Estado de riesgo EUDR",
      iybScores: "Puntuaciones IYB",
      importSpreadsheet: "Importar hoja de cálculo",
      noDataFound: "No se encontraron datos",
      noValidRegencyRows: "La hoja de cálculo no contenía filas de regencia válidas.",
      previewFailed: "Vista previa fallida",
      couldNotParseSpreadsheet: "No se pudo analizar la hoja de cálculo",
      couldNotLoadPreviewPage: "No se pudo cargar la página de vista previa",
      importSuccessTitle: "Puntuaciones IYB importadas correctamente",
      regenciesImported: "{count} regencias importadas",
      importFailed: "Importación fallida",
      couldNotImportSpreadsheet: "No se pudo importar la hoja de cálculo",
      iybRegionalScores: "Puntuaciones regionales IYB",
      iybRegionalScoresSubtitle: "Puntuaciones de indicadores de jurisdicción sostenible a nivel de regencia obtenidas de PTSI. Se usan para la Fase 2 de la verificación de cumplimiento de semáforo EUDR.",
      allIndonesiaDistricts: "Todos los distritos de Indonesia",
      greenLowRisk: "VERDE — Riesgo bajo",
      fastTrackEligible: "Apto para vía rápida",
      yellowMediumRisk: "AMARILLO — Riesgo medio",
      mitigationRequired: "Mitigación requerida",
      redHighRisk: "ROJO — Riesgo alto",
      blockedAppealPath: "Bloqueado, ruta de apelación disponible",
      searchRegencyName: "Buscar nombre de regencia...",
      filterByTier: "Filtrar por nivel",
      year: "Año",
      details: "Detalles",
      failedToLoadScores: "Error al cargar puntuaciones IYB",
      indicatorBreakdownTitle: "Desglose de indicadores IYB",
      regencyKabupaten: "Regencia / Kabupaten",
      environmental: "Ambiental",
      socialAgricultural: "Social y Agrícola",
      governance: "Gobernanza",
      scoreRanges: "Rangos de puntuación:",
      lowRiskRange: "Riesgo bajo (≥60)",
      mediumRiskRange: "Riesgo medio (40.01–59.99)",
      highRiskRange: "Riesgo alto (≤40)",
      trafficLightPanel: {
        viewAssessmentConditions: "Ver condiciones de la evaluación",
        landAssessmentNotYetRun: "La evaluación de tierras aún no se ha ejecutado",
        landAssessmentNotYetRunDesc: "Ejecute la verificación para evaluar las comprobaciones de polígonos basadas en mapas (zona de amortiguamiento forestal de 100 m) y la puntuación IYB del distrito (Kabupaten).",
        landPolygonAssessment: "Evaluación del Polígono de Tierras",
        landPolygonAssessmentDesc: "Análisis basado en mapas con una zona de amortiguamiento de 100 m del límite forestal",
        landPolygonAssessmentPreviewDesc: "Análisis de deforestación basado en mapas, superposición con bosque protegido y zona de amortiguamiento de 100 m",
        districtAssessment: "Evaluación del Distrito (Kabupaten)",
        districtAssessmentDesc: "Índice de sostenibilidad IYB a nivel de regencia",
        showIndicators: "Mostrar indicadores",
        hideIndicators: "Ocultar indicadores",
        unknownRegency: "Regencia Desconocida",
        localComplianceCheckIyb: "Verificación de Cumplimiento Local (IYB)",
        outOf100: "sobre 100,00",
        noIybDataForRegency: "No hay datos IYB para esta regencia",
        importIybToComplete: "Importe las puntuaciones regionales IYB para completar la evaluación.",
        palmOilFirePreventionCheck: "Aceite de Palma — Verificación de Prevención de Incendios",
        palmOilFirePreventionCheckDesc: "Indicador de Prevención de Incendios Forestales a nivel de distrito (IYBv2 BOGOR — ind2)",
        iybIndicatorScale: "Indicador IYBv2 BOGOR (ind2) — escala 0–100",
        palmOilDdsBlocked: "DDS de Aceite de Palma Bloqueado — No Hay Vía de Mitigación Disponible",
        palmOilDdsBlockedDesc: "Este distrito está clasificado como Rojo en Prevención de Incendios Forestales (indicador ≤ 40). Bajo el marco de cumplimiento local del aceite de palma, no existe una vía de mitigación. Este DDS no puede continuar hacia la presentación a PTSI para la exportación de aceite de palma a la UE.",
        firePreventionCheckPassed: "Verificación de Prevención de Incendios Superada — Se Requiere Análisis Satelital de Humedad",
        firePreventionCheckPassedGreen: "El distrito cumple el umbral de prevención de incendios (indicador ≥ 60). Continúe con el análisis satelital de humedad del suelo y la vegetación.",
        firePreventionCheckPassedYellow: "El distrito se encuentra en el rango medio de prevención de incendios (40–60). Se requiere un análisis satelital de humedad del suelo y la vegetación antes de la presentación a PTSI.",
        noFireIndicatorData: "No hay datos del indicador de Incendios Forestales y de Tierras para este distrito. Importe las puntuaciones regionales IYB para habilitar la verificación de prevención de incendios del aceite de palma.",
        wildfireAlertTitle: "Alerta de Susceptibilidad a Incendios Forestales",
        wildfireAlertDesc: "Informe de riesgo de incendio a nivel de finca derivado de datos satelitales y meteorológicos",
        wildfireAlertGenerated: "Informe Generado",
        wildfireAlertLoading: "Comprobando si hay una alerta de incendio forestal generada...",
        wildfireAlertNotFound: "No Generado",
        wildfireAlertNotFoundDesc: "Todavía no se ha generado ningún informe de susceptibilidad al fuego para este lugar de producción.",
        wildfireAlertNoGeometry: "Sin Límite de Finca",
        wildfireAlertNoGeometryDesc: "No hay datos de límite ni de ubicación disponibles para este lugar de producción, por lo que no se puede generar un informe de susceptibilidad al fuego.",
        wildfireAlertGenerating: "Generando el informe de susceptibilidad al fuego: en la primera solicitud puede tardar unos minutos...",
        wildfireAlertSaving: "Guardando el informe de susceptibilidad al fuego...",
        wildfireAlertReadyDesc: "Informe generado: el desglose de susceptibilidad al fuego se muestra a continuación",
        wildfireAlertClickToGenerate: "Haga clic en Generar para solicitar el informe de susceptibilidad al fuego de esta finca",
        wildfireAlertGenerate: "Generar Informe",
        wildfireAlertRegenerate: "Regenerar",
        wildfireAlertGenerateFailed: "No se pudo generar el informe de susceptibilidad al fuego. Por favor, inténtelo de nuevo.",
        wildfireAlertAreaLabel: "Área de la Finca",
        wildfireAlertModelLabel: "Modelo",
        wildfireAlertPolygonBoundary: "Límite Poligonal",
        wildfireAlertCircularArea: "Área Circular",
        wildfireAlertGeneratedOn: "Generado",
        wildfireAlertRiskBreakdownTitle: "Desglose de Riesgo por Área",
        wildfireAlertHighestRisk: "Riesgo Más Alto",
        wildfireAlertRiskLevelColumn: "Nivel de Riesgo",
        wildfireAlertAreaColumn: "Área (ha)",
        wildfireAlertShareColumn: "Proporción",
        wildfireAlertOverlayOpacity: "Opacidad de la capa",
        mitigationEvidence: "Pruebas de Mitigación",
        uploadedDocuments: "Documentos subidos",
        view: "Ver",
        remove: "Eliminar",
        clickToUploadOrDrop: "Haga clic para subir o arrastre y suelte",
        fileTypesMaxSize: "PDF, JPG, PNG, DOCX — máximo 10 MB cada uno",
        ready: "Listo",
        failed: "Fallido",
        uploadFailed: "Error al subir",
        uploadingToStorage: "Subiendo el archivo al almacenamiento seguro... | Subiendo los archivos al almacenamiento seguro...",
        submitEvidenceToPtsi: "Enviar Pruebas a PTSI",
        submittingToPtsi: "Enviando a PTSI...",
        fileExceedsLimit: "{name} supera el límite de 10 MB.",
        couldNotOpenMitigationDoc: "No se pudo abrir el documento de mitigación.",
        mitigationDocument: "Documento de mitigación",
        fileCount: "{count} archivo | {count} archivos",
        phase1AllClear: "Todo Correcto",
        phase1OneIssue: "1 Problema Encontrado",
        phase1IssuesFound: "{count} Problemas Encontrados",
        fireRiskLow: "Riesgo de incendio: Bajo",
        fireRiskMedium: "Riesgo de incendio: Medio",
        blocked: "BLOQUEADO",
        lowRiskGte60: "Riesgo bajo ≥60",
        mediumRisk: "Riesgo medio",
        highRiskLte40: "Riesgo alto ≤40",
        conditionsDocPalmOil: "Aceite de Palma — Anexo de Cumplimiento Local",
        conditionsDocCoffeeCocoa: "Anexo de Café/Cacao V2.1",
        legendFarmBoundary: "Límite de la finca",
        legendDeforestation: "Deforestación",
        legendProtectedForest: "Bosque protegido",
        legend100mBuffer: "Zona de 100 m",
        spatialDeforestationLabel: "Deforestación detectada (posterior a 2020)",
        spatialDeforestationShort: "Deforestación",
        spatialDeforestationHint: "Pérdida forestal posterior a 2020",
        spatialForestOverlapLabel: "Superposición con bosque protegido / de conservación",
        spatialForestOverlapShort: "Superposición Forestal",
        spatialForestOverlapHint: "Áreas protegidas",
        spatialBufferLabel: "A menos de 100 m del límite forestal",
        spatialBufferShort: "Zona de 100 m",
        spatialBufferHint: "Proximidad al límite forestal",
        chipDetected: "Detectado",
        chipOverlap: "Superposición",
        chipWithin100m: "A menos de 100 m",
        chipClear: "Sin hallazgos",
        phase1TooltipTitle: "Fase 1 — {label}",
        checkpointResult: "Resultado del punto de control: {result}",
        spatialDeforestationFail: "El análisis satelital detectó pérdida forestal posterior a 2020 dentro del límite de la finca. Este es un punto de control espacial crítico y normalmente desencadena una clasificación de riesgo alto.",
        spatialDeforestationPass: "No se detectó pérdida forestal posterior a 2020 dentro del límite de la finca.",
        spatialForestOverlapFail: "El polígono de la finca se superpone con el límite de un bosque protegido (zona de amortiguamiento de 100 m aplicada desde el borde del bosque). Futuras versiones integrarán capas cartográficas indonesias de hutan lindung, hutan sosial y hutan masyarakat adat.",
        spatialForestOverlapPass: "No se detectó superposición con áreas de bosque protegido o de conservación dentro de la zona de amortiguamiento de 100 m del límite.",
        spatialBufferWarn: "El límite de la finca está a menos de 100 m del borde de un bosque. Según las condiciones de la evaluación, puede requerirse mitigación incluso sin deforestación directa.",
        spatialBufferPass: "La finca está fuera de la zona de amortiguamiento de 100 m del límite forestal.",
        iybIndexUnavailable: "El índice regional de sostenibilidad de {regency} no está disponible.",
        iybScoreSummary: "Puntuación IYB de {regency}: {score} / 100,00 → {status}",
        regencyAssessed: "Regencia evaluada: {regency}",
        compositeIybScore: "Puntuación IYB compuesta: {score} sobre 100,00",
        scoreGreenFastTrack: "Puntuación ≥ {min} — Verde / apto para vía rápida (riesgo local bajo)",
        scoreYellowMitigation: "Puntuación {min}–{max} — Amarillo / riesgo local medio (mitigación recomendada)",
        scoreRedMandatory: "Puntuación ≤ {max} — Rojo claro / riesgo jurisdiccional local alto (mitigación obligatoria)",
        regionalRiskStatus: "Estado de riesgo regional: {status}",
        indicatorBreakdownAvailable: "Desglose de indicadores disponible: despliegue a continuación para ver cobertura del suelo, incendios, turba y otros factores IYB",
        localComplianceNotLoaded: "No se han cargado los datos de cumplimiento local de esta finca.",
        mitigationNoteYellow: "Esta finca requiere pruebas adicionales antes de que PTSI pueda aprobar el DDS. Suba los documentos de mitigación: se aplica un plazo de 90 días.",
        mitigationNoteRed: "Aunque está clasificada como de riesgo alto, existe una vía de mitigación. Suba pruebas de cumplimiento a nivel de finca para su revisión por PTSI.",
        unknownRegencyLower: "Regencia desconocida",
      },
      indicators: {
        spatialPlanning: "Planificación espacial",
        forestLandFires: "Incendios forestales y de tierras",
        waterWaste: "Agua y residuos",
        climateAction: "Acción climática",
        landExploitation: "Explotación de tierras",
        independentSmallholders: "Pequeños productores independientes",
        farmerInstitutions: "Instituciones de agricultores",
        businessPartnerships: "Alianzas empresariales",
        indigenousCommunities: "Comunidades indígenas",
        gender: "Género",
        spbeInformation: "Información SPBE",
        sp4nLaporComplaints: "Quejas SP4N-LAPOR",
        fpicSop: "SOP de FPIC",
      },
    },
  },

  diligenceGuide: {
    guide: "Guía",
    downloadPdfManual: "Descargar Manual en PDF",
    watchDemoVideo: "Ver Video Demostrativo",
    viewManualOnWeb: "Ver Manual en la Web",
  },
  welcomeScreenDiligenceGuide: {
    title: "Tu Centro Esencial de Guías",
    description: `Explora nuestra página de Guías de Ayuda del Sistema de Diligencia Debida de EUDR
      para recursos esenciales, incluidos manuales en PDF, tutoriales en video y asistencia
      basada en la web. Empodérate para navegar por la plataforma de manera eficiente
      y optimiza tu flujo de trabajo.`,
    continueToTheDueDiligenceSystem: "Continuar al Sistema de Diligencia Debida",

  },
  supportedRegions: {
    title: "Análisis Satelital del DDS — Países y Regiones Compatibles",
    description: "El análisis satelital de deforestación está disponible actualmente para fincas ubicadas en los siguientes países y regiones específicas. Haga clic en un país para ver las regiones cubiertas. Si sus lugares de producción están fuera de estas áreas, los datos de verificación de ubicación pueden ser limitados.",
    region: "región",
    regions: "regiones",
    footer: "Los datos de cobertura se actualizan continuamente. Contacte con soporte si su región no aparece en la lista.",
    showAll: "Mostrar los {count} países",
    showLess: "Mostrar menos",
  },
  assessmentStatus:{
    riskAssessmentSummary: "Resumen de Evaluación de Riesgos",
    riskAssessmentSummaryTT: "Resumen de Evaluación de Riesgos",
    totalNoOfFarms: "Número Total de Granjas",
    assessmentsCompleted: "Evaluaciones Completadas",
    assessmentsPending: "Evaluaciones Pendientes",
    requiredMitigation: "Mitigación Requerida",
  }
}